import React, { memo, useMemo, useState, useCallback, useEffect, useRef, useLayoutEffect, createContext, useContext } from 'react';
import { isNotDefined, listToGroupList, _cs, getContrastYIQ, getHexFromString, getColorOnBgColor, unique, isDefined, isFalsyString, bound, isTruthyString, modulo, caseInsensitiveSubmatch, compareStringSearch, listToMap, randomString, formattedNormalize, Lang, addSeparator, sum, compareNumber, compareBoolean, compareString, compareDate } from '@togglecorp/fujs';
import { scaleBand, scaleLinear } from 'd3-scale';
import ReactDOM from 'react-dom';
import ResizeObserver from 'resize-observer-polyfill';
import { SVGInjector } from '@tanem/svg-injector';
import { saveAs } from 'file-saver';
import TextareaAutosize from 'react-textarea-autosize';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$2 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$2
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$1 = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$1(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var path = {};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;






var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has$1(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global_1);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = functionBindContext(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has$1(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};

var ceil$1 = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil$1)(argument);
};

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$2(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max$2 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max$2(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$4 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$4(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$4(false)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

/* eslint-disable es/no-array-prototype-indexof -- required for testing */

var $indexOf = arrayIncludes.indexOf;


var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD$4 = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD$4 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var entryVirtual = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};

var indexOf$2 = entryVirtual('Array').indexOf;

var ArrayPrototype$c = Array.prototype;

var indexOf_1 = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype$c || (it instanceof Array && own === ArrayPrototype$c.indexOf) ? indexOf$2 : own;
};

var indexOf$1 = indexOf_1;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store$1 = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store$1;

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.10.1',
  mode: 'pure' ,
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var engineIsNode = classofRaw(global_1.process) == 'process';

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process = global_1.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // eslint-disable-next-line es/no-symbol -- required for testing
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (engineIsNode ? engineV8Version === 38 : engineV8Version > 37 && engineV8Version < 41);
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = nativeSymbol
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has$1(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has$1(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var SPECIES$2 = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('splice');

var max$1 = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max$1(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var splice$1 = entryVirtual('Array').splice;

var ArrayPrototype$b = Array.prototype;

var splice_1 = function (it) {
  var own = it.splice;
  return it === ArrayPrototype$b || (it instanceof Array && own === ArrayPrototype$b.splice) ? splice$1 : own;
};

var splice = splice_1;

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React.createContext && React.createContext(DefaultContext);

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return React.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return React.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? React.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// THIS FILE IS AUTO GENERATED
function IoIosArrowDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"}}]})(props);
}function IoIosArrowUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"}}]})(props);
}function IoMdClose (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"}}]})(props);
}function IoMdEyeOff (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.1 144.8c56.2 0 101.9 45.3 101.9 101.1 0 13.1-2.6 25.5-7.3 37l59.5 59c30.8-25.5 55-58.4 69.9-96-35.3-88.7-122.3-151.6-224.2-151.6-28.5 0-55.8 5.1-81.1 14.1l44 43.7c11.6-4.6 24.1-7.3 37.3-7.3zM52.4 89.7l46.5 46.1 9.4 9.3c-33.9 26-60.4 60.8-76.3 100.8 35.2 88.7 122.2 151.6 224.1 151.6 31.6 0 61.7-6.1 89.2-17l8.6 8.5 59.7 59 25.9-25.7L78.2 64 52.4 89.7zM165 201.4l31.6 31.3c-1 4.2-1.6 8.7-1.6 13.1 0 33.5 27.3 60.6 61.1 60.6 4.5 0 9-.6 13.2-1.6l31.6 31.3c-13.6 6.7-28.7 10.7-44.8 10.7-56.2 0-101.9-45.3-101.9-101.1 0-15.8 4.1-30.7 10.8-44.3zm87.8-15.7l64.2 63.7.4-3.2c0-33.5-27.3-60.6-61.1-60.6l-3.5.1z"}}]})(props);
}function IoMdEye (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 105c-101.8 0-188.4 62.4-224 151 35.6 88.6 122.2 151 224 151s188.4-62.4 224-151c-35.6-88.6-122.2-151-224-151zm0 251.7c-56 0-101.8-45.3-101.8-100.7S200 155.3 256 155.3 357.8 200.6 357.8 256 312 356.7 256 356.7zm0-161.1c-33.6 0-61.1 27.2-61.1 60.4s27.5 60.4 61.1 60.4 61.1-27.2 61.1-60.4-27.5-60.4-61.1-60.4z"}}]})(props);
}function IoMdTime (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"g","attr":{"fillOpacity":".9"},"child":[{"tag":"path","attr":{"d":"M255.8 48C141 48 48 141.2 48 256s93 208 207.8 208c115 0 208.2-93.2 208.2-208S370.8 48 255.8 48zm.2 374.4c-91.9 0-166.4-74.5-166.4-166.4S164.1 89.6 256 89.6 422.4 164.1 422.4 256 347.9 422.4 256 422.4z"}},{"tag":"path","attr":{"d":"M266.4 152h-31.2v124.8l109.2 65.5 15.6-25.6-93.6-55.5V152z"}}]}]})(props);
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _extends = /*@__PURE__*/getDefaultExportFromCjs(_extends_1);

var hiddenKeys = {};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var keys$2 = path.Object.keys;

var keys$1 = keys$2;

var test$2 = [];
var nativeSort = test$2.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$2.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$2.sort(null);
});
// Old WebKit
var STRICT_METHOD$3 = arrayMethodIsStrict('sort');

var FORCED$2 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$3;

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction$1(comparefn));
  }
});

var sort$1 = entryVirtual('Array').sort;

var ArrayPrototype$a = Array.prototype;

var sort_1 = function (it) {
  var own = it.sort;
  return it === ArrayPrototype$a || (it instanceof Array && own === ArrayPrototype$a.sort) ? sort$1 : own;
};

var sort = sort_1;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$3 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$3(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$3(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$3(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$3(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$3(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$3(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$3(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$3(7)
};

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var map$1 = entryVirtual('Array').map;

var ArrayPrototype$9 = Array.prototype;

var map_1 = function (it) {
  var own = it.map;
  return it === ArrayPrototype$9 || (it instanceof Array && own === ArrayPrototype$9.map) ? map$1 : own;
};

var map = map_1;

const typedMemo$1 = memo;
const emptyList$3 = [];

function hasGroup(props) {
  return !!props.grouped;
}

function GroupedList(props) {
  const {
    groupKeySelector,
    groupComparator,
    renderer: Renderer,
    groupRenderer: GroupRenderer,
    groupRendererClassName,
    groupRendererParams,
    data: dataFromProps,
    keySelector,
    rendererParams,
    rendererClassName
  } = props;
  const data = dataFromProps !== null && dataFromProps !== void 0 ? dataFromProps : emptyList$3;

  const renderListItem = (datum, i) => {
    const key = keySelector(datum, i);
    const extraProps = rendererParams(key, datum, i, data);
    return /*#__PURE__*/React.createElement(Renderer, _extends({
      key: key,
      className: rendererClassName
    }, extraProps));
  };

  const renderGroup = (groupKey, index, groupData, children) => {
    const extraProps = groupRendererParams(groupKey, index, groupData);
    const finalProps = { ...extraProps,
      className: groupRendererClassName,
      children
    };
    return /*#__PURE__*/React.createElement(GroupRenderer, _extends({
      key: groupKey // FIXME: currently typescript is not smart enough to join Omit

    }, finalProps));
  };

  const groups = useMemo(() => listToGroupList(data, groupKeySelector), [data, groupKeySelector]);
  const sortedGroupKeys = useMemo(() => {
    const keys = keys$1(groups);

    return sort(keys).call(keys, groupComparator);
  }, [groups, groupComparator]);

  const children = map(sortedGroupKeys).call(sortedGroupKeys, (groupKey, i) => {
    var _context;

    return renderGroup(groupKey, i, groups[groupKey], map(_context = groups[groupKey]).call(_context, renderListItem));
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}

function List(props) {
  const {
    data,
    keySelector,
    renderer: Renderer,
    rendererClassName,
    rendererParams
  } = props;

  if (isNotDefined(data)) {
    return null;
  }

  const renderListItem = (datum, i) => {
    const key = keySelector(datum, i);
    const extraProps = rendererParams(key, datum, i, data);
    return /*#__PURE__*/React.createElement(Renderer, _extends({
      key: key,
      className: rendererClassName
    }, extraProps));
  };

  if (!hasGroup(props)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, map(data).call(data, renderListItem));
  }

  return /*#__PURE__*/React.createElement(GroupedList, props);
}

var List$1 = typedMemo$1(List);

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};

var $trim = stringTrim.trim;


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
_export({ target: 'String', proto: true, forced: stringTrimForced('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var trim$2 = entryVirtual('String').trim;

var StringPrototype$2 = String.prototype;

var trim_1 = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype$2
    || (it instanceof String && own === StringPrototype$2.trim) ? trim$2 : own;
};

var trim$1 = trim_1;

const noOp = () => {
  console.warn('setUiMode called before it was assigned');
};

const ThemeContext = /*#__PURE__*/React.createContext({
  uiMode: 'light',
  setUiMode: noOp
});

function useThemeClassName(uiModeFromProps, lightClassName, darkClassName) {
  const {
    uiMode
  } = React.useContext(ThemeContext);
  const className = React.useMemo(() => {
    const map = {
      light: lightClassName,
      dark: darkClassName
    };
    return map[uiModeFromProps || uiMode];
  }, [uiModeFromProps, uiMode, lightClassName, darkClassName]);
  return className;
}

function useBlurEffect(shouldWatch, callback, elementRef, parentRef) {
  React.useEffect(() => {
    if (!shouldWatch) {
      return undefined;
    }

    const handleDocumentClick = e => {
      const {
        current: element
      } = elementRef;
      const {
        current: parent
      } = parentRef;
      const isElementOrContainedInElement = element ? element === e.target || element.contains(e.target) : false;
      const isParentOrContainedInParent = parent ? parent === e.target || parent.contains(e.target) : false;
      const clickedInside = isElementOrContainedInElement || isParentOrContainedInParent;
      callback(clickedInside, e);
    };

    document.addEventListener('click', handleDocumentClick, true);
    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [shouldWatch, callback, elementRef, parentRef]);
}

function useDropHandler(dragStartHandler, dropHandler) {
  const [dropping, setDropping] = React.useState(false);
  const dragEnterCount = React.useRef(0);

  const onDragOver = e => {
    e.preventDefault();
  };

  const onDragEnter = e => {
    if (dragEnterCount.current === 0) {
      setDropping(true);
      dragStartHandler(e);
    }

    dragEnterCount.current += 1;
  };

  const onDragLeave = () => {
    dragEnterCount.current -= 1;

    if (dragEnterCount.current === 0) {
      setDropping(false);
    }
  };

  const onDrop = e => {
    dragEnterCount.current = 0;
    setDropping(false);
    dropHandler(e);
    e.preventDefault();
  };

  return {
    dropping,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop
  };
}

var styles$L = {"visualFeedback":"styles_visual-feedback__2ann-","light":"styles_light__10hLy","focused":"styles_focused__2v0Cz","dark":"styles_dark__3w6aI","readOnly":"styles_read-only__35dG9","disabled":"styles_disabled__24aA6"};

function VisualFeedback(props) {
  const {
    className,
    disabled,
    readOnly,
    uiMode,
    focused
  } = props;
  const themeClassName = useThemeClassName(uiMode, styles$L.light, styles$L.dark);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles$L.visualFeedback, disabled && styles$L.disabled, readOnly && styles$L.readOnly, focused && styles$L.focused, themeClassName)
  });
}

var styles$K = {"rawButton":"styles_raw-button__1Q3tb","light":"styles_light__34mS6","dark":"styles_dark__AZ6Ys"};

/**
 * The most basic button component (without styles)
 */
function RawButton(props) {
  const {
    className,
    onClick,
    uiMode,
    children,
    disabled,
    elementRef,
    name,
    focused,
    ...otherProps
  } = props;
  const handleClick = React.useCallback(e => {
    if (onClick) {
      onClick(name, e);
    }
  }, [onClick, name]);
  const themeClassName = useThemeClassName(uiMode, styles$K.light, styles$K.dark);
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: elementRef,
    type: "button",
    className: _cs(className, styles$K.rawButton, themeClassName),
    disabled: disabled,
    onClick: onClick ? handleClick : undefined,
    name: name // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps), /*#__PURE__*/React.createElement(VisualFeedback, {
    disabled: disabled,
    uiMode: uiMode,
    focused: focused
  }), children);
}

var styles$J = {"button":"styles_button__3Yr7O","compact":"styles_compact__2B_FH","icons":"styles_icons__CFFGx","actions":"styles_actions__5GQgQ","children":"styles_children__1eVpD","light":"styles_light__3N_Kp","dark":"styles_dark__3OUy6","innerLight":"styles_inner-light__1mV6r","innerDark":"styles_inner-dark__1lUHI","default":"styles_default__16-3B","accent":"styles_accent__1ELB6","danger":"styles_danger__2adnJ","primary":"styles_primary__15nU3","success":"styles_success__21LEY","warning":"styles_warning__2zGXx","transparent":"styles_transparent__7UHcA","disabled":"styles_disabled__3y42d"};

const buttonVariantToVariableNameMap = {
  accent: '--tui-color-accent',
  danger: '--tui-color-danger',
  primary: '--tui-color-primary',
  warning: '--tui-color-warning',
  success: '--tui-color-success',
  default: '--tui-color-background-button'
};
function useButtonFeatures(props) {
  const {
    variant = 'default',
    className: classNameFromProps,
    actionsClassName,
    iconsClassName,
    childrenClassName,
    disabled,
    transparent = false,
    children,
    icons,
    actions,
    uiMode,
    compact
  } = props;
  const innerUiMode = useMemo(() => {
    var _context;

    // NOTE: color is returned as ' #ffffff' in development but '#ffffff' on production
    const color = trim$1(_context = getComputedStyle(document.documentElement).getPropertyValue(buttonVariantToVariableNameMap[variant])).call(_context); // Remove hash from color


    const luma = getContrastYIQ(color);
    const mode = luma >= 0.5 ? 'light' : 'dark';
    const invertMap = {
      light: 'dark',
      dark: 'light'
    };
    return transparent ? invertMap[mode] : mode;
  }, [variant, transparent]);
  const themeClassName = useThemeClassName(uiMode, styles$J.light, styles$J.dark);
  const innerThemeClassName = useThemeClassName(innerUiMode, styles$J.innerLight, styles$J.innerDark);

  const buttonClassName = _cs(classNameFromProps, styles$J.button, variant, styles$J[variant], transparent && styles$J.transparent, themeClassName, innerThemeClassName, compact && styles$J.compact, disabled && styles$J.disabled);

  const buttonChildren = /*#__PURE__*/React.createElement(React.Fragment, null, icons && /*#__PURE__*/React.createElement("div", {
    className: _cs(iconsClassName, styles$J.icons)
  }, icons), children && /*#__PURE__*/React.createElement("div", {
    className: _cs(childrenClassName, styles$J.children)
  }, children), actions && /*#__PURE__*/React.createElement("div", {
    className: _cs(actionsClassName, styles$J.actions)
  }, actions));
  return {
    className: buttonClassName,
    children: buttonChildren,
    uiMode: transparent ? uiMode : innerUiMode,
    disabled
  };
}
/**
 * Basic button component
 */

function Button(props) {
  const {
    variant,
    className,
    actionsClassName,
    iconsClassName,
    childrenClassName,
    transparent = false,
    children,
    icons,
    actions,
    uiMode,
    disabled,
    compact,
    type = 'button',
    ...otherProps
  } = props;
  const buttonProps = useButtonFeatures({
    variant,
    className,
    actionsClassName,
    iconsClassName,
    childrenClassName,
    transparent,
    children,
    icons,
    actions,
    uiMode,
    compact,
    disabled
  });
  return /*#__PURE__*/React.createElement(RawButton, _extends({
    type: type // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps, buttonProps));
}

function ToggleButton(props) {
  const {
    value,
    onChange,
    ...otherProps
  } = props;
  const handleButtonClick = React.useCallback((name, e) => {
    if (onChange) {
      onChange(!value, name, e);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleButtonClick // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps));
}

var styles$I = {"accordion":"styles_accordion__1I0MS","group":"styles_group__3zKYz","groupHeader":"styles_group-header__ucdgp","groupTitle":"styles_group-title__3ZaAz","actions":"styles_actions__wJ8mr"};

function AccordionGroup({
  data,
  children,
  groupKey,
  groupIndex,
  groupOpened,
  setGroupOpen,
  groupHeaderClassName,
  groupClassName,
  groupTitleRenderer: GroupTitleRenderer,
  groupTitleRendererParams
}) {
  const handleGroupClick = useCallback(() => {
    setGroupOpen(groupKey);
  }, [groupKey, setGroupOpen]);
  const titleExtraProps = useMemo(() => groupTitleRendererParams(groupKey, groupIndex, data), [groupTitleRendererParams, data, groupKey, groupIndex]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$I.group, groupClassName)
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    className: _cs(styles$I.groupHeader, groupHeaderClassName),
    name: "group-header",
    value: groupOpened,
    onChange: handleGroupClick,
    actionsClassName: styles$I.actions,
    actions: groupOpened ? /*#__PURE__*/React.createElement(IoIosArrowUp, null) : /*#__PURE__*/React.createElement(IoIosArrowDown, null),
    childrenClassName: styles$I.groupTitle,
    transparent: true
  }, /*#__PURE__*/React.createElement(GroupTitleRenderer, titleExtraProps)), groupOpened && /*#__PURE__*/React.createElement(React.Fragment, null, children));
} // eslint-disable-next-line max-len


function Accordion(props) {
  const {
    groupTitleRenderer,
    groupTitleRendererParams,
    groupClassName,
    groupHeaderClassName,
    multipleExpandEnabled,
    groupKeySelector,
    groupComparator,
    renderer,
    data,
    keySelector,
    rendererParams,
    rendererClassName
  } = props;
  const [openGroups, setOpenGroups] = useState([]);
  const handleGroupOpenChange = useCallback(groupKey => {
    let newOpenGroups = [...openGroups];

    const selectedGroupIndex = indexOf$1(newOpenGroups).call(newOpenGroups, groupKey);

    if (selectedGroupIndex !== -1) {
      if (multipleExpandEnabled) {
        splice(newOpenGroups).call(newOpenGroups, selectedGroupIndex, 1);
      } else {
        newOpenGroups = [];
      }
    } else if (multipleExpandEnabled) {
      newOpenGroups.push(groupKey);
    } else {
      newOpenGroups = [groupKey];
    }

    setOpenGroups(newOpenGroups);
  }, [openGroups, setOpenGroups, multipleExpandEnabled]);
  const groupRendererParams = useCallback((key, index, allData) => ({
    data: allData,
    groupKey: key,
    groupIndex: index,
    groupOpened: indexOf$1(openGroups).call(openGroups, key) !== -1,
    setGroupOpen: handleGroupOpenChange,
    groupTitleRenderer,
    groupClassName,
    groupHeaderClassName,
    groupTitleRendererParams
  }), [handleGroupOpenChange, openGroups, groupTitleRenderer, groupHeaderClassName, groupClassName, groupTitleRendererParams]); // NOTE: setting this directly idk why it doesn't work otherwise

  return /*#__PURE__*/React.createElement("div", {
    className: styles$I.accordion
  }, /*#__PURE__*/React.createElement(List$1, {
    groupKeySelector: groupKeySelector,
    groupComparator: groupComparator,
    groupRenderer: AccordionGroup,
    groupRendererParams: groupRendererParams,
    grouped: true,
    renderer: renderer,
    data: data,
    keySelector: keySelector,
    rendererParams: rendererParams,
    rendererClassName: rendererClassName
  }));
}

var styles$H = {"avatar":"styles_avatar__gdIPG","image":"styles_image__1rUzk","icon":"styles_icon__3DDTy"};

function getInitials(name) {
  var _context;

  if (name.length <= 0) {
    return '?';
  }

  const letters = map(_context = trim$1(name).call(name).split(/\s/)).call(_context, item => item[0]);

  return letters.length <= 1 ? letters[0] : `${letters[0]}${letters[letters.length - 1]}`;
}

function useImage(props) {
  const {
    src,
    srcSet
  } = props;
  const hasImage = src || srcSet;
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    setLoading(true);
    setHasError(false);

    const handleLoad = () => {
      setLoading(false);
      setHasError(false);
    };

    const handleError = () => {
      setLoading(false);
      setHasError(true);
    };

    const image = new Image();
    image.addEventListener('error', handleError);
    image.addEventListener('load', handleLoad);

    if (src) {
      image.src = src;
    }

    if (srcSet) {
      image.srcset = srcSet;
    }

    return () => {
      image.removeEventListener('error', handleError);
      image.removeEventListener('load', handleLoad);
    };
  }, [src, srcSet]);
  return {
    isLoading: loading,
    hasError,
    hasImage
  };
}

function Avatar(props) {
  const {
    className: classNameFromProps,
    alt,
    src,
    srcSet,
    ...otherProps
  } = props;
  const {
    isLoading,
    hasError,
    hasImage
  } = useImage({
    src,
    srcSet
  });

  const className = _cs(classNameFromProps, styles$H.avatar);

  if (!hasImage || hasError || isLoading) {
    const initials = getInitials(alt);
    const backgroundColor = getHexFromString(alt);
    const textColor = getColorOnBgColor(backgroundColor);
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$H.icon,
      style: {
        backgroundColor,
        color: textColor
      }
    }, initials));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("img", _extends({
    className: styles$H.image,
    alt: alt,
    src: src,
    srcSet: srcSet
  }, otherProps)));
}

var styles$G = {"backdrop":"styles_backdrop__1fstY","light":"styles_light__6pT92","dark":"styles_dark__3IMoz"};

function Backdrop(props) {
  const {
    className,
    parentRef,
    children,
    uiMode
  } = props;
  const ref = React.useRef(null);
  const themeClassName = useThemeClassName(uiMode, styles$G.light, styles$G.dark);
  React.useLayoutEffect(() => {
    const {
      current: el
    } = ref;

    if (parentRef && parentRef.current && el) {
      const parentBCR = parentRef.current.getBoundingClientRect();
      el.style.width = `${parentBCR.width}px`;
    }
  }, [parentRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: _cs(className, styles$G.backdrop, themeClassName)
  }, children);
}

var styles$F = {"line":"styles_line__13tx8","label":"styles_label__3OoWK"};

var _context;

const colorAccent = trim$1(_context = getComputedStyle(document.documentElement).getPropertyValue('--tui-color-accent')).call(_context);

const defaultColorSelector = () => colorAccent;

const defaultMargin = {
  top: 10,
  right: 0,
  bottom: 32,
  left: 48
};

function BarChart(props) {
  const {
    width,
    height,
    data,
    valueSelector,
    labelSelector,
    colorSelector = defaultColorSelector,
    margin = defaultMargin
  } = props;
  const {
    top,
    right,
    bottom,
    left
  } = margin;
  const x = useMemo(() => scaleBand().domain(map(data).call(data, d => labelSelector(d))).range([left, width - right]).padding(0.1), [data, labelSelector, left, right, width]);
  const y = useMemo(() => {
    var _Math$max;

    const maxValue = (_Math$max = Math.max(...map(data).call(data, valueSelector))) !== null && _Math$max !== void 0 ? _Math$max : 0;
    return scaleLinear().domain([0, maxValue]).nice().range([height - bottom, top]);
  }, [data, valueSelector, bottom, top, height]);

  const xAxisLabels = map(data).call(data, d => /*#__PURE__*/React.createElement("g", {
    key: `x-axis-label-${labelSelector(d)}`,
    transform: `translate(${x(labelSelector(d))}, ${y(0)})`
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    className: styles$F.label,
    x: x.bandwidth() / 2,
    y: 10,
    dy: "0.75em"
  }, labelSelector(d))));

  const ticks = y.ticks(height / 50);

  const yAxisLabels = map(ticks).call(ticks, d => /*#__PURE__*/React.createElement("g", {
    key: `y-axis-label-${d}`,
    transform: `translate(${left}, ${y(d)})`
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "end",
    className: styles$F.label,
    y: 0,
    x: -5,
    dy: "0.32em"
  }, d)));

  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height
  }, map(data).call(data, d => {
    var _y, _y2;

    const xHeight = ((_y = y(0)) !== null && _y !== void 0 ? _y : 0) - ((_y2 = y(valueSelector(d))) !== null && _y2 !== void 0 ? _y2 : 0);
    return /*#__PURE__*/React.createElement("g", {
      key: `bar-${labelSelector(d)}`,
      fill: colorSelector(d)
    }, /*#__PURE__*/React.createElement("rect", {
      y: y(valueSelector(d)),
      x: x(labelSelector(d)),
      height: xHeight,
      width: x.bandwidth()
    }));
  }), /*#__PURE__*/React.createElement("g", {
    key: "x-axis"
  }, /*#__PURE__*/React.createElement("line", {
    className: styles$F.line,
    x1: left,
    y1: y(0),
    x2: width,
    y2: y(0)
  }), xAxisLabels), /*#__PURE__*/React.createElement("g", {
    key: "y-axis"
  }, /*#__PURE__*/React.createElement("line", {
    className: styles$F.line,
    x1: left,
    y1: y(0),
    x2: left,
    y2: -height
  }), yAxisLabels));
}

function Portal(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal(children, document.body));
}

var styles$E = {"bodyBackdrop":"styles_body-backdrop__2C-tY","light":"styles_light__2lDqg","dark":"styles_dark__25gXI"};

function BodyBackdrop(props) {
  const {
    children,
    className,
    uiMode
  } = props;
  const themeClassName = useThemeClassName(uiMode, styles$E.light, styles$E.dark);
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles$E.bodyBackdrop, themeClassName)
  }, children));
}

var $filter = arrayIteration.filter;


var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var filter$1 = entryVirtual('Array').filter;

var ArrayPrototype$8 = Array.prototype;

var filter_1 = function (it) {
  var own = it.filter;
  return it === ArrayPrototype$8 || (it instanceof Array && own === ArrayPrototype$8.filter) ? filter$1 : own;
};

var filter = filter_1;

var $some = arrayIteration.some;


var STRICT_METHOD$2 = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$2 }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var some$1 = entryVirtual('Array').some;

var ArrayPrototype$7 = Array.prototype;

var some_1 = function (it) {
  var own = it.some;
  return it === ArrayPrototype$7 || (it instanceof Array && own === ArrayPrototype$7.some) ? some$1 : own;
};

var some = some_1;

var styles$D = {"inputContainer":"styles_input-container__2itys","light":"styles_light__2xAsI","readOnly":"styles_read-only__3VbKq","disabled":"styles_disabled__2di36","errored":"styles_errored__2Nmm8","dark":"styles_dark__38WtJ","inputLabel":"styles_input-label__2G0DX","inputSection":"styles_input-section__2t5jc","icons":"styles_icons__3SZif","input":"styles_input__1kjpC","actions":"styles_actions__5uA8U","hint":"styles_hint__pz16R","error":"styles_error__1XTo6"};

/**
 * Common container for input elements
 */
const InputContainer = /*#__PURE__*/React.forwardRef(({
  className,
  uiMode,
  label,
  labelContainerClassName,
  inputSectionClassName,
  inputContainerClassName,
  icons,
  iconsContainerClassName,
  actions,
  actionsContainerClassName,
  input,
  hintContainerClassName,
  errorContainerClassName,
  disabled,
  readOnly,
  containerRef: containerRefFromProps,
  hint,
  error,
  inputSectionRef,
  invalid
}, ref) => {
  const themeClassName = useThemeClassName(uiMode, styles$D.light, styles$D.dark);
  const containerRef = containerRefFromProps !== null && containerRefFromProps !== void 0 ? containerRefFromProps : ref;
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: _cs(className, styles$D.inputContainer, themeClassName, disabled && styles$D.disabled, readOnly && styles$D.readOnly, (invalid || !!error) && styles$D.errored)
  }, label && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$D.inputLabel, labelContainerClassName)
  }, label), /*#__PURE__*/React.createElement("div", {
    ref: inputSectionRef,
    className: _cs(styles$D.inputSection, inputSectionClassName)
  }, icons && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$D.icons, iconsContainerClassName)
  }, icons), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$D.input, inputContainerClassName)
  }, input), actions && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$D.actions, actionsContainerClassName)
  }, actions)), error && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$D.error, errorContainerClassName)
  }, error), !error && hint && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$D.hint, hintContainerClassName)
  }, hint));
});

// THIS FILE IS AUTO GENERATED
function MdCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"}}]})(props);
}function MdCheckBox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"}}]})(props);
}function MdCheckBoxOutlineBlank (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"}}]})(props);
}function MdIndeterminateCheckBox (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"}}]})(props);
}

var styles$C = {};

function Checkmark(props) {
  const {
    className,
    indeterminate,
    value
  } = props;

  const iconClassName = _cs(className, styles$C.checkmark, 'tui-checkmark');

  return /*#__PURE__*/React.createElement(React.Fragment, null, indeterminate && /*#__PURE__*/React.createElement(MdIndeterminateCheckBox, {
    className: iconClassName
  }), value && !indeterminate && /*#__PURE__*/React.createElement(MdCheckBox, {
    className: iconClassName
  }), !value && !indeterminate && /*#__PURE__*/React.createElement(MdCheckBoxOutlineBlank, {
    className: iconClassName
  }));
}

var styles$B = {"checkbox":"styles_checkbox__nWaMC","checkmark":"styles_checkmark__1n1g9","input":"styles_input__21Dwb","label":"styles_label__2Jvgr","light":"styles_light__1fcO7","checked":"styles_checked__FHqom","indeterminate":"styles_indeterminate__3YCh1","dark":"styles_dark__2NSq0","readOnly":"styles_read-only__p3fGW","disabled":"styles_disabled__39uhX"};

function Checkbox(props) {
  const {
    label,
    tooltip,
    checkmark: Checkmark$1 = Checkmark,
    className: classNameFromProps,
    value,
    disabled,
    readOnly,
    onChange,
    checkmarkClassName,
    labelClassName,
    indeterminate,
    uiMode,
    name,
    ...otherProps
  } = props;
  const handleChange = useCallback(e => {
    const v = e.currentTarget.checked;
    onChange(v, name);
  }, [name, onChange]);
  const themeClassName = useThemeClassName(uiMode, styles$B.light, styles$B.dark);

  const className = _cs(styles$B.checkbox, classNameFromProps, indeterminate && styles$B.indeterminate, !indeterminate && value && styles$B.checked, disabled && styles$B.disabled, readOnly && styles$B.readOnly, themeClassName);

  return /*#__PURE__*/React.createElement("label", {
    // eslint-disable-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for
    className: className,
    title: tooltip
  }, /*#__PURE__*/React.createElement(VisualFeedback, {
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/React.createElement(Checkmark$1, {
    className: _cs(checkmarkClassName, styles$B.checkmark),
    value: value !== null && value !== void 0 ? value : false,
    indeterminate: indeterminate,
    uiMode: uiMode
  }), /*#__PURE__*/React.createElement("input", _extends({
    onChange: handleChange,
    className: styles$B.input,
    type: "checkbox",
    checked: value !== null && value !== void 0 ? value : false,
    disabled: disabled || readOnly
  }, otherProps)), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$B.label, labelClassName)
  }, label));
}

var styles$A = {"checkListInput":"styles_check-list-input__2PN9f","checkListContainer":"styles_check-list-container__3mnIq","vertical":"styles_vertical__3hwcP","horizontal":"styles_horizontal__U6mn-"};

function CheckListInput(props) {
  const {
    className,
    disabled,
    error,
    icons,
    actions,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    name,
    value,
    options,
    onChange,
    keySelector,
    labelSelector,
    inputContainerClassName,
    inputSectionClassName,
    actionsContainerClassName,
    iconsContainerClassName,
    checkboxLabelClassName,
    checkboxClassName,
    direction = 'horizontal'
  } = props;
  const handleCheck = useCallback((isSelected, key) => {
    if (isSelected) {
      onChange([...(value !== null && value !== void 0 ? value : []), key], name);
    } else {
      var _context;

      onChange([...filter(_context = value !== null && value !== void 0 ? value : []).call(_context, v => v !== key)], name);
    }
  }, [value, onChange, name]);
  const optionListRendererParams = useCallback((key, data) => {
    var _context2;

    return {
      name: key,
      value: some(_context2 = value !== null && value !== void 0 ? value : []).call(_context2, v => v === key),
      onChange: handleCheck,
      label: labelSelector(data),
      labelClassName: checkboxLabelClassName,
      uiMode,
      disabled,
      readOnly
    };
  }, [value, handleCheck, labelSelector, uiMode, disabled, readOnly, checkboxLabelClassName]);
  return /*#__PURE__*/React.createElement(InputContainer, {
    className: _cs(styles$A.checkListInput, className, direction === 'horizontal' && styles$A.horizontal, direction === 'vertical' && styles$A.vertical),
    actionsContainerClassName: actionsContainerClassName,
    labelContainerClassName: labelContainerClassName,
    inputSectionClassName: inputSectionClassName,
    errorContainerClassName: errorContainerClassName,
    hintContainerClassName: hintContainerClassName,
    iconsContainerClassName: iconsContainerClassName,
    disabled: disabled,
    error: error,
    hint: hint,
    icons: icons,
    label: label,
    readOnly: readOnly,
    uiMode: uiMode,
    actions: actions,
    inputContainerClassName: _cs(styles$A.checkListContainer, inputContainerClassName),
    input: /*#__PURE__*/React.createElement(List$1, {
      data: options,
      keySelector: keySelector,
      renderer: Checkbox,
      rendererParams: optionListRendererParams,
      rendererClassName: checkboxClassName
    })
  });
}

var styles$z = {"chip":"styles_chip__1ECgq","disabled":"styles_disabled__3cpZ5","default":"styles_default__2FyuQ","accent":"styles_accent__28sN1","danger":"styles_danger__3Jfhf","primary":"styles_primary__17jms","success":"styles_success__2mstq","warning":"styles_warning__1lBMq","light":"styles_light__1jtep","dark":"styles_dark__1ArwO","innerLight":"styles_inner-light__tuBLl","innerDark":"styles_inner-dark__3BpXQ","icon":"styles_icon___Mf2H","label":"styles_label__2jRvF","children":"styles_children__LB1Xm","action":"styles_action__EGCzu"};

const chipVariantToVariableNameMap = {
  accent: '--tui-color-accent',
  danger: '--tui-color-danger',
  primary: '--tui-color-primary',
  warning: '--tui-color-warning',
  success: '--tui-color-success',
  default: '--tui-color-background-button'
};

function Chip(props) {
  const {
    variant = 'default',
    label,
    icon,
    action,
    className,
    labelClassName,
    iconClassName,
    actionClassName,
    children,
    childrenClassName,
    disabled
  } = props;
  const innerUiMode = useMemo(() => {
    var _context;

    const color = trim$1(_context = getComputedStyle(document.documentElement).getPropertyValue(chipVariantToVariableNameMap[variant])).call(_context);

    const luma = getContrastYIQ(color);
    const mode = luma >= 0.5 ? 'light' : 'dark';
    return mode;
  }, [variant]);
  const themeClassName = useThemeClassName(innerUiMode, styles$z.light, styles$z.dark);
  const innerThemeClassName = useThemeClassName(innerUiMode, styles$z.innerLight, styles$z.innerDark);

  const chipClassName = _cs(className, styles$z.chip, variant, styles$z[variant], themeClassName, innerThemeClassName, disabled && styles$z.disabled);

  return /*#__PURE__*/React.createElement("div", {
    className: chipClassName
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$z.icon, iconClassName)
  }, icon), children && /*#__PURE__*/React.createElement("div", {
    className: _cs(childrenClassName, styles$z.children)
  }, children), !children && label && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$z.label, labelClassName)
  }, label), action && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$z.action, actionClassName)
  }, action));
}

var styles$y = {"modal":"styles_modal__1fhDd","modalHeader":"styles_modal-header__2u2mQ","titleContainer":"styles_title-container__C4dZ1","actions":"styles_actions__1tHiT","closeButton":"styles_close-button__2ryNn","modalBody":"styles_modal-body__2oibx","modalFooter":"styles_modal-footer__3vjYe","light":"styles_light__1COv2","dark":"styles_dark__2EdL3","extraSmallSize":"styles_extra-small-size__3a_Er","smallSize":"styles_small-size__3aT_m","mediumSize":"styles_medium-size__1Lyi9","largeSize":"styles_large-size__urk7H","coverSize":"styles_cover-size__3dDLp","freeHeight":"styles_free-height__2F1QS"};

const sizeToStyleMap = {
  extraSmall: styles$y.extraSmallSize,
  small: styles$y.smallSize,
  medium: styles$y.mediumSize,
  large: styles$y.largeSize,
  cover: styles$y.coverSize
};

function Modal(props) {
  const {
    heading,
    children,
    footer,
    className,
    headingClassName,
    bodyClassName,
    footerClassName,
    backdropClassName,
    size = 'medium',
    freeHeight,
    onClose,
    uiMode,
    closeButtonHidden
  } = props;
  const themeClassName = useThemeClassName(uiMode, styles$y.light, styles$y.dark);
  return /*#__PURE__*/React.createElement(BodyBackdrop, {
    className: backdropClassName,
    uiMode: uiMode
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles$y.modal, themeClassName, sizeToStyleMap[size], freeHeight && styles$y.freeHeight)
  }, heading !== null && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$y.modalHeader, headingClassName)
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles$y.titleContainer
  }, heading), !closeButtonHidden && /*#__PURE__*/React.createElement("div", {
    className: styles$y.actions
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles$y.closeButton,
    onClick: onClose,
    transparent: true,
    name: "Close",
    uiMode: uiMode
  }, /*#__PURE__*/React.createElement(IoMdClose, null)))), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$y.modalBody, bodyClassName)
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$y.modalFooter, footerClassName)
  }, footer)));
}

var styles$x = {"actionButtonsRow":"styles_action-buttons-row__1iUDC","actionButton":"styles_action-button__1YWOg"};

function ConfirmButton(props) {
  const {
    confirmationHeader = 'Confirmation',
    confirmationMessage = 'Are you sure?',
    onConfirm,
    onCancel,
    confirmButtonClassName,
    cancelButtonClassName,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    ...otherProps
  } = props;
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const handleConfirmModalShow = useCallback(() => {
    setShowConfirmModal(true);
  }, []);
  const handleConfirmModalClose = useCallback(() => {
    if (onCancel) {
      onCancel();
    }

    setShowConfirmModal(false);
  }, [onCancel]);
  const handleConfirmModalConfirm = useCallback(() => {
    onConfirm();
    setShowConfirmModal(false);
  }, [onConfirm]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    onClick: handleConfirmModalShow
  })), showConfirmModal && /*#__PURE__*/React.createElement(Modal, {
    heading: confirmationHeader,
    onClose: handleConfirmModalClose,
    footerClassName: styles$x.actionButtonsRow,
    freeHeight: true,
    size: "medium",
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: _cs(styles$x.actionButton, cancelButtonClassName),
      name: "cancel-button",
      onClick: handleConfirmModalClose
    }, cancelLabel), /*#__PURE__*/React.createElement(Button, {
      className: _cs(styles$x.actionButton, confirmButtonClassName),
      name: "confirm-button",
      onClick: handleConfirmModalConfirm,
      variant: "primary",
      autoFocus: true
    }, confirmLabel))
  }, confirmationMessage));
}

var styles$w = {"dummy":"styles_dummy__1Js4r","cover":"styles_cover__1jOeK"};

function Cover(props) {
  const {
    className,
    children
  } = props;
  const dummyRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const resizeObserverRef = React.useRef();
  const mutationObserverRef = React.useRef();
  const callbackRef = React.useRef();
  const queueSync = React.useCallback(() => {
    if (callbackRef.current) {
      window.cancelIdleCallback(callbackRef.current);
    }

    callbackRef.current = window.requestIdleCallback(() => {
      if (dummyRef.current && containerRef.current) {
        var _dummyRef$current$par;

        const bcr = (_dummyRef$current$par = dummyRef.current.parentElement) === null || _dummyRef$current$par === void 0 ? void 0 : _dummyRef$current$par.getBoundingClientRect();
        const {
          top,
          left,
          width,
          height
        } = bcr !== null && bcr !== void 0 ? bcr : {};
        containerRef.current.style.left = `${left}px`;
        containerRef.current.style.top = `${top}px`;
        containerRef.current.style.width = `${width}px`;
        containerRef.current.style.height = `${height}px`;
      }
    }, {
      timeout: 200
    });
  }, []);
  const handleResize = queueSync;
  const handleScroll = queueSync;
  const handleAttributeMutation = React.useCallback(e => {
    if (e[0].target === containerRef.current) {
      queueSync();
    }
  }, [queueSync]);
  React.useEffect(() => {
    const {
      current: container
    } = dummyRef;

    if (!container || !container.parentElement) ; else {
      document.addEventListener('scroll', handleScroll);
      resizeObserverRef.current = new ResizeObserver(handleResize);
      resizeObserverRef.current.observe(container.parentElement);
      mutationObserverRef.current = new MutationObserver(handleAttributeMutation);
      mutationObserverRef.current.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    return () => {
      document.removeEventListener('scroll', handleScroll);

      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }

      if (mutationObserverRef.current) {
        mutationObserverRef.current.disconnect();
      }
    };
  }, [handleResize, handleAttributeMutation, handleScroll]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: dummyRef,
    className: styles$w.dummy
  }), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$w.cover, className),
    ref: containerRef
  }, children)));
}

// THIS FILE IS AUTO GENERATED
function IoCalendarOutline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"rect","attr":{"width":"416","height":"384","x":"48","y":"80","fill":"none","strokeLinejoin":"round","strokeWidth":"32","rx":"48"}},{"tag":"circle","attr":{"cx":"296","cy":"232","r":"24"}},{"tag":"circle","attr":{"cx":"376","cy":"232","r":"24"}},{"tag":"circle","attr":{"cx":"296","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"376","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"136","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"216","cy":"312","r":"24"}},{"tag":"circle","attr":{"cx":"136","cy":"392","r":"24"}},{"tag":"circle","attr":{"cx":"216","cy":"392","r":"24"}},{"tag":"circle","attr":{"cx":"296","cy":"392","r":"24"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M128 48v32m256-32v32"}},{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M464 160H48"}}]})(props);
}function IoChevronBack (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M328 112L184 256l144 144"}}]})(props);
}function IoChevronDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 184l144 144 144-144"}}]})(props);
}function IoChevronForward (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M184 112l144 144-144 144"}}]})(props);
}function IoClose (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"}}]})(props);
}function IoRadioButtonOff (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}}]})(props);
}function IoRadioButtonOn (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"}},{"tag":"circle","attr":{"cx":"256","cy":"256","r":"144"}}]})(props);
}function IoRefreshOutline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32","d":"M320 146s24.36-12-64-12a160 160 0 10160 160"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 58l80 80-80 80"}}]})(props);
}function IoTimeOutline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeMiterlimit":"10","strokeWidth":"32","d":"M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 128v144h96"}}]})(props);
}

function useBooleanState(initialValue) {
  const [value, setValue] = React.useState(initialValue);
  const setTrue = React.useCallback(() => {
    setValue(true);
  }, [setValue]);
  const setFalse = React.useCallback(() => {
    setValue(false);
  }, [setValue]);
  const toggleFn = React.useCallback(() => {
    setValue(oldValue => !oldValue);
  }, [setValue]);
  return [value, setTrue, setFalse, setValue, toggleFn];
}

var styles$v = {"rawInput":"styles_raw-input__1tUgz"};

/**
 * The most basic input component (without styles)
 */
function RawInput({
  className,
  onChange,
  uiMode,
  elementRef,
  value,
  name,
  disabled,
  readOnly,
  autoComplete = 'off',
  ...otherProps
}) {
  const handleChange = React.useCallback(e => {
    const {
      currentTarget: {
        value: v
      }
    } = e;

    if (onChange) {
      onChange(v === '' ? undefined : v, name, e);
    }
  }, [name, onChange]);
  const themeClassName = useThemeClassName(uiMode, styles$v.light, styles$v.dark);
  return /*#__PURE__*/React.createElement("input", _extends({
    ref: elementRef,
    className: _cs(className, styles$v.rawInput, themeClassName),
    onChange: handleChange,
    name: name,
    value: value !== null && value !== void 0 ? value : '',
    disabled: disabled,
    readOnly: readOnly,
    autoComplete: autoComplete // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps));
}

var styles$u = {"popup":"styles_popup__3VPpy","tip":"styles_tip__gK93C","top":"styles_top__2oKQG","bottom":"styles_bottom__hw2c0","left":"styles_left__3XNf9","right":"styles_right__xObbL","content":"styles_content__3HHHw"};

const defaultPlacement = {
  top: 'unset',
  right: 'unset',
  bottom: 'unset',
  left: 'unset'
};

function getFloatPlacement(parentRef) {
  const placement = { ...defaultPlacement
  };
  let horizontalPosition;
  let verticalPosition;
  let contentWidth = 'auto';
  let maxHeight = 'auto';

  if (parentRef !== null && parentRef !== void 0 && parentRef.current) {
    const parentBCR = parentRef.current.getBoundingClientRect();
    const {
      x,
      y,
      width,
      height
    } = parentBCR;
    const cX = window.innerWidth / 2;
    const cY = window.innerHeight / 2;
    horizontalPosition = cX - parentBCR.x > 0 ? 'right' : 'left';
    verticalPosition = cY - parentBCR.y > 0 ? 'bottom' : 'top';

    if (horizontalPosition === 'left') {
      placement.right = `${window.innerWidth - x - width}px`;
    } else if (horizontalPosition === 'right') {
      placement.left = `${x}px`;
    }

    if (verticalPosition === 'top') {
      placement.bottom = `${window.innerHeight - y + 10}px`;
    } else if (verticalPosition === 'bottom') {
      placement.top = `${y + height + 10}px`;
    }

    contentWidth = `${width}px`;
    maxHeight = `calc(50vh - ${height / 2}px)`;
  }

  return {
    placement,
    width: contentWidth,
    horizontalPosition,
    verticalPosition,
    maxHeight
  };
}

function useAttachedFloatingPlacement(parentRef) {
  const [placement, setPlacement] = React.useState({
    placement: defaultPlacement,
    width: 'auto',
    maxHeight: 'auto',
    horizontalPosition: 'left',
    verticalPosition: 'top'
  });
  React.useLayoutEffect(() => {
    setPlacement(getFloatPlacement(parentRef));
  }, [setPlacement, parentRef]); // FIXME: throttle

  const handleScroll = React.useCallback(() => {
    setPlacement(getFloatPlacement(parentRef));
  }, [setPlacement, parentRef]); // FIXME: throttle

  const handleResize = React.useCallback(() => {
    setPlacement(getFloatPlacement(parentRef));
  }, [setPlacement, parentRef]);
  React.useEffect(() => {
    document.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleResize, true);
    return () => {
      document.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', handleResize, true);
    };
  }, [handleScroll, handleResize]);
  return placement;
}

function Popup(props) {
  const {
    parentRef,
    children,
    className,
    contentClassName,
    freeWidth,
    elementRef
  } = props;
  const {
    placement,
    width,
    horizontalPosition,
    verticalPosition,
    maxHeight
  } = useAttachedFloatingPlacement(parentRef);
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    style: placement,
    ref: elementRef,
    className: _cs(styles$u.popup, className, horizontalPosition === 'left' ? styles$u.left : styles$u.right, verticalPosition === 'top' ? styles$u.top : styles$u.bottom)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$u.tip
  }), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$u.content, contentClassName),
    style: {
      minWidth: !freeWidth ? width : undefined,
      maxHeight
    }
  }, children)));
}

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
_export({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});

var maxSafeInteger$1 = 0x1FFFFFFFFFFFFF;

var maxSafeInteger = maxSafeInteger$1;

var styles$t = {"optionRenderer":"styles_option-renderer__2p2Pd"};

function GenericOption({
  optionContainerClassName,
  contentRenderer,
  contentRendererParam,
  option,
  onClick,
  onFocus,
  optionKey,
  focusedKey
}) {
  const params = contentRendererParam(optionKey, option);
  const {
    containerClassName,
    title,
    ...props
  } = params;
  const isFocused = (focusedKey === null || focusedKey === void 0 ? void 0 : focusedKey.key) === optionKey; //  && focusedKey?.mouse;

  const divRef = useRef(null);
  const focusedByMouse = useRef(false);
  useEffect(() => {
    if (focusedKey && focusedKey.key === optionKey && !focusedKey.mouse && divRef.current) {
      divRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [optionKey, focusedKey, isFocused]);
  const handleClick = useCallback(() => {
    onClick(optionKey, option);
  }, [optionKey, option, onClick]);
  const handleMouseMove = useCallback(() => {
    if (onFocus) {
      onFocus({
        key: optionKey,
        mouse: true
      });
    }
  }, [onFocus, optionKey]);
  const handleMouseLeave = useCallback(() => {
    focusedByMouse.current = false;
  }, []);
  return /*#__PURE__*/React.createElement(RawButton, {
    elementRef: divRef,
    className: _cs(styles$t.optionRenderer, optionContainerClassName, containerClassName),
    onClick: handleClick,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    title: title,
    name: optionKey,
    focused: isFocused
  }, contentRenderer(props));
}

var styles$s = {"popup":"styles_popup__2BN8M","popupContent":"styles_popup-content__3LMBt","listItem":"styles_list-item__HWf9d","suggestionHeader":"styles_suggestion-header__29nkv","label":"styles_label__2IL_x"};

function Option$2(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$s.label
  }, children);
}

function processSuggestions(items, keySelector, blacklist) {
  var _context;

  if (!items) {
    return [];
  }

  return filter(_context = unique(items, keySelector)).call(_context, item => keySelector(item) !== blacklist);
}

function RawInputWithSuggestion(props) {
  const {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    suggestions,
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    suggestionKeySelector,
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    suggestionLabelSelector,
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    suggestionsPopupClassName,
    containerRef,
    inputSectionRef,
    value,
    name,
    onChange,
    readOnly,
    ...otherProps
  } = props;
  const [showDropdown, setShowDropdown] = React.useState(false);
  const inputElementRef = React.useRef(null);
  const popupRef = React.useRef(null);
  const handlePopupBlur = React.useCallback(isClickedWithin => {
    if (!isClickedWithin) {
      setShowDropdown(false);
    }
  }, []);
  const handleSearchInputClick = React.useCallback(() => {
    if (readOnly) {
      return;
    }

    setShowDropdown(true);
  }, [readOnly, setShowDropdown]);
  const handleOptionClick = React.useCallback(key => {
    if (onChange) {
      onChange(key, name, undefined);
    }

    setShowDropdown(false);
  }, [name, onChange]);
  const processedSuggestions = React.useMemo(() => {
    if (!props.suggestionKeySelector) {
      return [];
    }

    return processSuggestions(props.suggestions, props.suggestionKeySelector, value);
  }, [props.suggestions, props.suggestionKeySelector, value]);
  const optionRendererParams = React.useCallback((_, option) => {
    let children;

    if (props.suggestionLabelSelector) {
      children = props.suggestionLabelSelector(option);
    }

    return {
      children,
      // containerClassName: ,
      title: children
    };
  }, [props.suggestionLabelSelector]);
  const optionListRendererParams = React.useCallback((key, option) => ({
    contentRendererParam: optionRendererParams,
    contentRenderer: Option$2,
    option,
    optionKey: key,
    onClick: handleOptionClick,
    optionContainerClassName: _cs(styles$s.listItem, props.suggestionContainerClassName)
  }), [optionRendererParams, props.suggestionContainerClassName, handleOptionClick]);
  useBlurEffect(showDropdown, handlePopupBlur, popupRef, containerRef);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RawInput, _extends({
    name: name,
    onChange: onChange,
    elementRef: inputElementRef,
    onClick: handleSearchInputClick,
    value: value
  }, otherProps)), showDropdown && props.suggestionKeySelector && processedSuggestions.length > 0 && /*#__PURE__*/React.createElement(Popup, {
    elementRef: popupRef,
    parentRef: inputSectionRef,
    className: _cs(props.suggestionsPopupClassName, styles$s.popup),
    contentClassName: styles$s.popupContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$s.suggestionHeader
  }, "Suggestion"), /*#__PURE__*/React.createElement(List$1, {
    data: processedSuggestions,
    keySelector: props.suggestionKeySelector,
    renderer: GenericOption,
    rendererParams: optionListRendererParams
  })));
}

function isValidNumericString(val) {
  return /^[+-]?\d+(\.\d+)?$/.test(val);
}

function isValidDecimalTrailingZeroString(val) {
  return /^[+-]?\d+\.\d*0$/.test(val);
}

function NumberInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    onChange,
    name,
    value,
    ...rawInputProps
  } = props;
  const containerRef = React.useRef(null);
  const inputSectionRef = React.useRef(null);
  const [tempValue, setTempValue] = useState();
  useLayoutEffect(() => {
    // NOTE: we don't clear tempValue if it is equal to input value
    // eg. tempValue: 1.00000, value: 1
    setTempValue(val => isDefined(val) && isValidNumericString(val) && +val === value ? val : undefined);
  }, [value]);
  const handleChange = React.useCallback((v, n, event) => {
    if (!onChange) {
      return;
    }

    if (isFalsyString(v)) {
      setTempValue(undefined);
      onChange(undefined, n, event);
      return;
    }

    if (!isValidNumericString(v)) {
      setTempValue(v);
      return;
    } // NOTE: we set tempValue if it is valid but is a transient state
    // eg. 1.0000 is valid but transient


    setTempValue(isValidDecimalTrailingZeroString(v) ? v : undefined);
    const numericValue = bound(+v, -maxSafeInteger, maxSafeInteger);
    onChange(numericValue, n, event);
  }, [onChange]);
  const handleFocusOut = useCallback(() => {
    setTempValue(undefined);
  }, []);
  const finalValue = tempValue !== null && tempValue !== void 0 ? tempValue : isDefined(value) ? String(value) : undefined;
  return /*#__PURE__*/React.createElement(InputContainer, {
    ref: containerRef,
    inputSectionRef: inputSectionRef,
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    invalid: isTruthyString(tempValue),
    input: /*#__PURE__*/React.createElement(RawInputWithSuggestion, _extends({}, rawInputProps, {
      containerRef: containerRef,
      inputSectionRef: inputSectionRef,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      onChange: handleChange,
      onBlur: handleFocusOut,
      name: name,
      value: finalValue
    }))
  });
}

var $find = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var find$1 = entryVirtual('Array').find;

var ArrayPrototype$6 = Array.prototype;

var find_1 = function (it) {
  var own = it.find;
  return it === ArrayPrototype$6 || (it instanceof Array && own === ArrayPrototype$6.find) ? find$1 : own;
};

var find = find_1;

var $findIndex = arrayIteration.findIndex;


var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var findIndex$1 = entryVirtual('Array').findIndex;

var ArrayPrototype$5 = Array.prototype;

var findIndex_1 = function (it) {
  var own = it.findIndex;
  return it === ArrayPrototype$5 || (it instanceof Array && own === ArrayPrototype$5.findIndex) ? findIndex$1 : own;
};

var findIndex = findIndex_1;

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes$3 = entryVirtual('Array').includes;

var MATCH$1 = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes$2 = entryVirtual('String').includes;

var ArrayPrototype$4 = Array.prototype;
var StringPrototype$1 = String.prototype;

var includes$1 = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype$4 || (it instanceof Array && own === ArrayPrototype$4.includes)) return includes$3;
  if (typeof it === 'string' || it === StringPrototype$1 || (it instanceof String && own === StringPrototype$1.includes)) {
    return includes$2;
  } return own;
};

var includes = includes$1;

// eslint-disable-next-line import/prefer-default-export
var Keys;
/*
# Feature
- Handles setting value of focusedKey exclusively
*/

(function (Keys) {
  Keys[Keys["Tab"] = 9] = "Tab";
  Keys[Keys["Esc"] = 27] = "Esc";
  Keys[Keys["Enter"] = 13] = "Enter";
  Keys[Keys["Down"] = 38] = "Down";
  Keys[Keys["Up"] = 40] = "Up";
  Keys[Keys["Backspace"] = 8] = "Backspace";
})(Keys || (Keys = {}));

const specialKeys = [Keys.Up, Keys.Down, Keys.Enter, Keys.Backspace];

function getOptionIndex(key, options, keySelector) {
  return findIndex(options).call(options, (o, i) => keySelector(o, i) === key);
}

function getNewKey(oldKey, increment, options, keySelector) {
  if (options.length <= 0) {
    return undefined;
  }

  const index = getOptionIndex(oldKey, options, keySelector); // NOTE: index should never be -1 to begin with

  let oldIndex = index;

  if (oldIndex === -1) {
    oldIndex = increment > 0 ? -1 : 0;
  }

  const newIndex = modulo(oldIndex + increment, options.length);
  return keySelector(options[newIndex], newIndex);
}

function useKeyboard(focusedKey, keySelector, options, isOptionsShown, onFocusChange, onHideOptions, onShowOptions, onOptionSelect) {
  const handleKeyDown = useCallback(e => {
    // NOTE: De-structuring e here will create access error
    const {
      keyCode
    } = e;
    const myKey = focusedKey === null || focusedKey === void 0 ? void 0 : focusedKey.key;

    if (isOptionsShown && (keyCode === Keys.Tab || keyCode === Keys.Esc)) {
      // If tab or escape was pressed and dropdown is being shown,
      // hide the dropdown.
      onHideOptions();
    } else if (!isOptionsShown && includes(specialKeys).call(specialKeys, keyCode)) {
      // If any of the special keys was pressed but the dropdown is currently hidden,
      // show the dropdown.
      e.stopPropagation();
      e.preventDefault();
      onShowOptions();
    } else if (keyCode === Keys.Enter) {
      if (isDefined(myKey)) {
        e.stopPropagation();
        e.preventDefault();

        const focusedOption = find(options).call(options, (option, i) => keySelector(option, i) === myKey);

        if (focusedOption) {
          onOptionSelect(myKey, focusedOption);
        }
      }
    } else if (keyCode === Keys.Up) {
      e.stopPropagation();
      e.preventDefault();
      const newFocusedKey = getNewKey(myKey, 1, options, keySelector);
      onFocusChange(newFocusedKey ? {
        key: newFocusedKey
      } : undefined);
    } else if (keyCode === Keys.Down) {
      e.stopPropagation();
      e.preventDefault();
      const newFocusedKey = getNewKey(myKey, -1, options, keySelector);
      onFocusChange(newFocusedKey ? {
        key: newFocusedKey
      } : undefined);
    }
  }, [focusedKey, isOptionsShown, keySelector, onFocusChange, onHideOptions, onOptionSelect, onShowOptions, options]);
  return handleKeyDown;
}

var styles$r = {"empty":"styles_empty__37K02"};

function EmptyOptions(props) {
  const {
    filtered = false,
    pending = false,
    optionsCount,
    totalOptionsCount = 0
  } = props;

  if (pending) {
    // FIXME: use loading
    return /*#__PURE__*/React.createElement("div", {
      className: styles$r.empty
    }, "Fetching options...");
  }

  if (optionsCount <= 0) {
    if (filtered) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$r.empty
      }, "No matching options available.");
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles$r.empty
    }, "No options available.");
  } // When optionsCount is zero, totalOptionsCount should be zero as well


  const hiddenOptions = totalOptionsCount - optionsCount;

  if (hiddenOptions > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$r.empty
    }, `and ${hiddenOptions} more`);
  }

  return null;
}

var styles$q = {"popup":"styles_popup__2UVCx","popupContent":"styles_popup-content__343tN","group":"styles_group__TVSK8","groupHeader":"styles_group-header__3kN3G","groupChildren":"styles_group-children__2n2MF","listItem":"styles_list-item__bPLRV"};

function Group({
  className,
  title,
  children,
  headerContainerClassName,
  childrenContainerClassName
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles$q.group)
  }, /*#__PURE__*/React.createElement("header", {
    className: _cs(headerContainerClassName, styles$q.groupHeader),
    title: title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: _cs(childrenContainerClassName, styles$q.groupChildren)
  }, children));
}

const emptyList$2 = []; // eslint-disable-next-line @typescript-eslint/ban-types, max-len

function SelectInputContainer(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    name,
    onOptionClick,
    searchText,
    onSearchTextChange,
    optionContainerClassName,
    optionKeySelector,
    optionRenderer,
    optionRendererParams,
    options: optionsFromProps,
    optionsPopupClassName,
    optionsPopupContentClassName,
    persistentOptionPopup,
    readOnly,
    placeholder,
    uiMode,
    valueDisplay = '',
    nonClearable,
    onClear,
    optionsPending,
    optionsFiltered,
    focused,
    focusedKey,
    onFocusedKeyChange,
    onFocusedChange,
    dropdownShown,
    onDropdownShownChange,
    totalOptionsCount,
    hasValue,
    autoFocus
  } = props;
  const options = optionsFromProps !== null && optionsFromProps !== void 0 ? optionsFromProps : emptyList$2;
  const containerRef = useRef(null);
  const inputSectionRef = useRef(null);
  const inputElementRef = useRef(null);
  const popupRef = useRef(null);
  const handleSearchInputChange = useCallback(value => {
    if (!dropdownShown) {
      onDropdownShownChange(true);
    }

    onSearchTextChange(value);
  }, [dropdownShown, onDropdownShownChange, onSearchTextChange]);
  const handleToggleDropdown = useCallback(() => {
    onDropdownShownChange(!dropdownShown);
  }, [dropdownShown, onDropdownShownChange]);
  const handleShowDropdown = useCallback(() => {
    // FIXME: this is not atomic
    // FIXME: call only once
    if (!dropdownShown) {
      onDropdownShownChange(true);
    }
  }, [dropdownShown, onDropdownShownChange]);
  const handleHideDropdown = useCallback(() => {
    onDropdownShownChange(false);
  }, [onDropdownShownChange]);
  const handleSearchInputClick = useCallback(() => {
    if (readOnly) {
      return;
    }

    handleShowDropdown();
  }, [readOnly, handleShowDropdown]);
  const handlePopupBlur = useCallback(isClickedWithin => {
    if (!isClickedWithin) {
      handleHideDropdown();
    } else if (persistentOptionPopup && inputElementRef.current) {
      inputElementRef.current.focus();
    }
  }, [handleHideDropdown, persistentOptionPopup]);
  const handleOptionClick = useCallback((valueKey, value) => {
    onOptionClick(valueKey, value, name);

    if (!persistentOptionPopup) {
      handleHideDropdown();
    }
  }, [onOptionClick, handleHideDropdown, persistentOptionPopup, name]);
  const optionListRendererParams = useCallback((key, option) => ({
    contentRendererParam: optionRendererParams,
    option,
    optionKey: key,
    focusedKey,
    contentRenderer: optionRenderer,
    onClick: handleOptionClick,
    onFocus: onFocusedKeyChange,
    optionContainerClassName: _cs(optionContainerClassName, styles$q.listItem)
  }), [focusedKey, handleOptionClick, onFocusedKeyChange, optionContainerClassName, optionRenderer, optionRendererParams]);
  const groupRendererParams = useCallback((_, __, values) => ({
    title: props.grouped ? props.groupLabelSelector(values[0]) : '?'
  }), // FIXME: disabling because linter is not smart enough
  // eslint-disable-next-line react-hooks/exhaustive-deps, react/destructuring-assignment
  [props.grouped, props.groupLabelSelector]);
  useBlurEffect(dropdownShown, handlePopupBlur, popupRef, containerRef);
  const handleKeyDown = useKeyboard(focusedKey, optionKeySelector, options, dropdownShown, onFocusedKeyChange, handleHideDropdown, handleShowDropdown, handleOptionClick);
  let popup; // eslint-disable-next-line react/destructuring-assignment

  if (props.grouped) {
    popup = /*#__PURE__*/React.createElement(List$1, {
      data: options,
      keySelector: optionKeySelector,
      renderer: GenericOption,
      rendererParams: optionListRendererParams,
      grouped: true,
      groupRenderer: Group,
      groupRendererParams: groupRendererParams,
      groupKeySelector: props.groupKeySelector
    });
  } else {
    popup = /*#__PURE__*/React.createElement(List$1, {
      data: options,
      keySelector: optionKeySelector,
      renderer: GenericOption,
      rendererParams: optionListRendererParams
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputContainer, {
    ref: containerRef,
    inputSectionRef: inputSectionRef,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !readOnly && !nonClearable && hasValue && /*#__PURE__*/React.createElement(Button, {
      onClick: onClear,
      disabled: disabled,
      transparent: true,
      compact: true,
      uiMode: uiMode,
      name: undefined,
      title: "Clear"
    }, /*#__PURE__*/React.createElement(IoMdClose, null)), !readOnly && /*#__PURE__*/React.createElement(Button, {
      onClick: handleToggleDropdown,
      transparent: true,
      compact: true,
      uiMode: uiMode,
      name: undefined,
      title: dropdownShown ? 'Close' : 'Open'
    }, dropdownShown ? /*#__PURE__*/React.createElement(IoIosArrowUp, null) : /*#__PURE__*/React.createElement(IoIosArrowDown, null))),
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(RawInput, {
      name: name,
      elementRef: inputElementRef,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      value: dropdownShown || focused ? searchText : valueDisplay,
      onChange: handleSearchInputChange,
      onClick: handleSearchInputClick,
      onFocus: () => onFocusedChange(true),
      onBlur: () => onFocusedChange(false),
      placeholder: isTruthyString(valueDisplay) ? valueDisplay : placeholder,
      autoComplete: "off",
      onKeyDown: handleKeyDown,
      autoFocus: autoFocus
    })
  }), dropdownShown && /*#__PURE__*/React.createElement(Popup, {
    elementRef: popupRef,
    parentRef: inputSectionRef,
    className: _cs(optionsPopupClassName, styles$q.popup),
    contentClassName: _cs(styles$q.popupContent, optionsPopupContentClassName)
  }, popup, /*#__PURE__*/React.createElement(EmptyOptions, {
    filtered: optionsFiltered,
    pending: optionsPending,
    optionsCount: options.length,
    totalOptionsCount: totalOptionsCount
  })));
}

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var slice$1 = entryVirtual('Array').slice;

var ArrayPrototype$3 = Array.prototype;

var slice_1 = function (it) {
  var own = it.slice;
  return it === ArrayPrototype$3 || (it instanceof Array && own === ArrayPrototype$3.slice) ? slice$1 : own;
};

var slice = slice_1;

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
_export({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});

var now$1 = path.Date.now;

var now = now$1;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

// https://github.com/tc39/proposal-string-pad-start-end




var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod$1 = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = stringRepeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod$1(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod$1(true)
};

// https://github.com/zloirock/core-js/issues/280


// eslint-disable-next-line unicorn/no-unsafe-regex -- safe
var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(engineUserAgent);

var $padStart = stringPad.start;


// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
_export({ target: 'String', proto: true, forced: stringPadWebkitBug }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var padStart$1 = entryVirtual('String').padStart;

var StringPrototype = String.prototype;

var padStart_1 = function (it) {
  var own = it.padStart;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.padStart) ? padStart$1 : own;
};

var padStart = padStart_1;

function rankedSearchOnList(list, searchString, labelSelector) {
  var _context;

  if (isFalsyString(searchString)) {
    return list;
  }

  return sort(_context = filter(list).call(list, option => caseInsensitiveSubmatch(labelSelector(option), searchString))).call(_context, (a, b) => compareStringSearch(labelSelector(a), labelSelector(b), searchString));
}
function getLocalISOString() {
  var _context2;

  const tzoffset = new Date().getTimezoneOffset() * 60000;

  const localISOTime = slice(_context2 = new Date(now() - tzoffset).toISOString()).call(_context2, 0, -1);

  return localISOTime;
}
const typedMemo = memo;
function ymdToDateString(year, month, day) {
  var _context3, _context4, _context5;

  const ys = padStart(_context3 = String(year)).call(_context3, 4, '0');

  const ms = padStart(_context4 = String(month + 1)).call(_context4, 2, '0');

  const ds = padStart(_context5 = String(day)).call(_context5, 2, '0');

  return `${ys}-${ms}-${ds}`;
}
function dateStringToDate(value) {
  return new Date(`${value}T00:00`);
}
const getHashFromBrowser = () => window.location.hash.substr(2);
const setHashToBrowser = hash => {
  if (hash) {
    window.location.replace(`#/${hash}`);
  } else {
    window.location.hash = '';
  }
};

var styles$p = {"option":"styles_option__s3Liq","icon":"styles_icon__2cypQ","label":"styles_label__3jlfd","active":"styles_active__H_u9C"};

function Option$1(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$p.icon
  }, /*#__PURE__*/React.createElement(MdCheck, null)), /*#__PURE__*/React.createElement("div", {
    className: styles$p.label
  }, children));
}

const emptyList$1 = [];

function SearchSelectInput(props) {
  var _optionsLabelMap$valu;

  const {
    keySelector,
    labelSelector,
    name,
    onChange,
    onOptionsChange,
    options: optionsFromProps,
    optionsPending,
    value,
    sortFunction,
    searchOptions: searchOptionsFromProps,
    onSearchValueChange,
    onShowDropdownChange,
    ...otherProps
  } = props;
  const options = optionsFromProps !== null && optionsFromProps !== void 0 ? optionsFromProps : emptyList$1;
  const searchOptions = searchOptionsFromProps !== null && searchOptionsFromProps !== void 0 ? searchOptionsFromProps : emptyList$1;
  const [searchInputValue, setSearchInputValue] = React.useState('');
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [focused, setFocused] = React.useState(false);
  const [focusedKey, setFocusedKey] = React.useState();
  const [selectedKeys, setSelectedKeys] = useState({});
  const optionsLabelMap = useMemo(() => listToMap(options, keySelector, labelSelector), [options, keySelector, labelSelector]);
  const valueDisplay = isDefined(value) ? (_optionsLabelMap$valu = optionsLabelMap[value]) !== null && _optionsLabelMap$valu !== void 0 ? _optionsLabelMap$valu : '?' : ''; // NOTE: we can skip this calculation if optionsShowInitially is false

  const selectedOptions = useMemo(() => {
    const selectedValue = options === null || options === void 0 ? void 0 : find(options).call(options, item => keySelector(item) === value);
    return !selectedValue ? [] : [selectedValue];
  }, [value, options, keySelector]);
  const realOptions = useMemo(() => {
    const allOptions = unique([...searchOptions, ...selectedOptions], keySelector);

    const initiallySelected = filter(allOptions).call(allOptions, item => selectedKeys[keySelector(item)]);

    const initiallyNotSelected = filter(allOptions).call(allOptions, item => !selectedKeys[keySelector(item)]);

    if (sortFunction) {
      return [...rankedSearchOnList(initiallySelected, searchInputValue, labelSelector), ...sortFunction(initiallyNotSelected, searchInputValue, labelSelector)];
    }

    return [...rankedSearchOnList(initiallySelected, searchInputValue, labelSelector), ...initiallyNotSelected];
  }, [keySelector, labelSelector, searchInputValue, searchOptions, selectedKeys, selectedOptions, sortFunction]);
  const handleSearchValueChange = useCallback(searchValue => {
    setSearchInputValue(searchValue);

    if (onSearchValueChange) {
      onSearchValueChange(searchValue);
    }
  }, [onSearchValueChange]);
  const handleChangeDropdown = useCallback(myVal => {
    setShowDropdown(myVal);

    if (onShowDropdownChange) {
      onShowDropdownChange(myVal);
    }

    if (myVal) {
      setSelectedKeys(listToMap(value ? [value] : [], item => item, () => true));
      setFocusedKey(value ? {
        key: value
      } : undefined);
    } else {
      setSelectedKeys({});
      setFocusedKey(undefined);
      setSearchInputValue('');

      if (onSearchValueChange) {
        onSearchValueChange('');
      }
    }
  }, [value, onSearchValueChange, onShowDropdownChange]);
  const optionRendererParams = useCallback((key, option) => {
    const isActive = key === value;
    return {
      children: labelSelector(option),
      containerClassName: _cs(styles$p.option, isActive && styles$p.active),
      title: labelSelector(option)
    };
  }, [value, labelSelector]);
  const handleOptionClick = useCallback((k, v) => {
    if (onOptionsChange) {
      onOptionsChange(existingOptions => {
        const safeOptions = existingOptions !== null && existingOptions !== void 0 ? existingOptions : [];

        const opt = find(safeOptions).call(safeOptions, item => keySelector(item) === k);

        if (opt) {
          return existingOptions;
        }

        return [...safeOptions, v];
      });
    }

    onChange(k, name, v);
  }, [onChange, name, onOptionsChange, keySelector]);
  const handleClear = useCallback(() => {
    if (!props.nonClearable) {
      props.onChange(undefined, name, undefined);
    }
  }, // eslint-disable-next-line react/destructuring-assignment
  [name, props.onChange, props.nonClearable]);
  return /*#__PURE__*/React.createElement(SelectInputContainer, _extends({}, otherProps, {
    name: name,
    options: realOptions,
    optionsPending: optionsPending,
    optionsFiltered: (searchInputValue === null || searchInputValue === void 0 ? void 0 : searchInputValue.length) > 0,
    optionKeySelector: keySelector,
    optionRenderer: Option$1,
    optionRendererParams: optionRendererParams,
    optionContainerClassName: styles$p.optionContainer,
    onOptionClick: handleOptionClick,
    valueDisplay: valueDisplay,
    onClear: handleClear,
    searchText: searchInputValue,
    onSearchTextChange: handleSearchValueChange,
    dropdownShown: showDropdown,
    onDropdownShownChange: handleChangeDropdown,
    focused: focused,
    onFocusedChange: setFocused,
    focusedKey: focusedKey,
    onFocusedKeyChange: setFocusedKey,
    hasValue: isDefined(value),
    persistentOptionPopup: false
  }));
}

// eslint-disable-next-line @typescript-eslint/ban-types
function SelectInput(props) {
  const {
    name,
    options,
    labelSelector,
    nonClearable,
    // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
    onChange,
    // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
    totalOptionsCount,
    // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
    ...otherProps
  } = props; // NOTE: this looks weird but we need to use typeguard to identify between
  // different union types (for onChange and nonClearable)
  // eslint-disable-next-line react/destructuring-assignment

  if (props.nonClearable) {
    return /*#__PURE__*/React.createElement(SearchSelectInput, _extends({}, otherProps, {
      // eslint-disable-next-line react/destructuring-assignment
      onChange: props.onChange // eslint-disable-next-line react/destructuring-assignment
      ,
      nonClearable: props.nonClearable,
      name: name,
      options: options,
      labelSelector: labelSelector,
      sortFunction: rankedSearchOnList,
      searchOptions: options
    }));
  }

  return /*#__PURE__*/React.createElement(SearchSelectInput, _extends({}, otherProps, {
    // eslint-disable-next-line react/destructuring-assignment
    onChange: props.onChange // eslint-disable-next-line react/destructuring-assignment
    ,
    nonClearable: props.nonClearable,
    name: name,
    options: options,
    labelSelector: labelSelector,
    sortFunction: rankedSearchOnList,
    searchOptions: options
  }));
}

function isSetterFn(value) {
  return typeof value === 'function';
}

function useInputState(initialValue) {
  const [value, setValue] = React.useState(initialValue);
  const setValueSafe = React.useCallback(newValueOrSetter => {
    setValue(oldValue => isSetterFn(newValueOrSetter) ? newValueOrSetter(oldValue) : newValueOrSetter);
  }, []);
  return [value, setValueSafe];
}

var styles$o = {"date":"styles_date__2Q8dq","today":"styles_today__2uwQ5","active":"styles_active__37w4m","ghost":"styles_ghost__1VJJL"};

function CalendarDate(props) {
  const {
    className,
    year,
    month,
    date,
    currentYear,
    currentMonth,
    currentDate,
    onClick,
    elementRef,
    activeDate,
    ghost
  } = props;
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(year, month, date);
    }
  }, [year, month, date, onClick]);
  const dateString = ymdToDateString(year, month, date);
  return /*#__PURE__*/React.createElement(RawButton, {
    elementRef: elementRef,
    name: date,
    className: _cs(styles$o.date, year === currentYear && month === currentMonth && currentDate === date && styles$o.today, dateString === activeDate && styles$o.active, ghost && styles$o.ghost, className),
    onClick: handleClick
  }, date);
}

var CalendarDate$1 = typedMemo(CalendarDate);

var styles$n = {"calendar":"styles_calendar__2CBtV","header":"styles_header__3rc7j","info":"styles_info__1Xgrv","currentYear":"styles_current-year__1tRn_","currentMonth":"styles_current-month__1I7_5","weekDays":"styles_week-days__3BZVG","weekDayName":"styles_week-day-name__32c6f","dayList":"styles_day-list__1ZhTX","dayContainer":"styles_day-container__n71QB","emptyDayList":"styles_empty-day-list__98U2j","icon":"styles_icon__2OigB","actions":"styles_actions__3FHdk","monthSelectionPopup":"styles_month-selection-popup__2RNFA","popupContent":"styles_popup-content__8F9hY","dummyDate":"styles_dummy-date__-Eqd_"};

const weekDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthNameList = [{
  key: 0,
  label: 'January'
}, {
  key: 1,
  label: 'February'
}, {
  key: 2,
  label: 'March'
}, {
  key: 3,
  label: 'April'
}, {
  key: 4,
  label: 'May'
}, {
  key: 5,
  label: 'June'
}, {
  key: 6,
  label: 'July'
}, {
  key: 7,
  label: 'August'
}, {
  key: 8,
  label: 'September'
}, {
  key: 9,
  label: 'October'
}, {
  key: 10,
  label: 'November'
}, {
  key: 11,
  label: 'December'
}];

function getStartOfWeek(year, month) {
  return new Date(year, month, 1).getDay();
}

function getNumDaysInMonth(year, month) {
  // Setting date to 0 will switch the date to last day of previous month
  return new Date(year, month + 1, 0).getDate();
}

function getDates(year, month) {
  const numDays = getNumDaysInMonth(year, month);
  const numDayInPrevMonth = getNumDaysInMonth(year, month - 1);
  const startOfWeek = getStartOfWeek(year, month);
  const dates = [];

  for (let i = 0; i < startOfWeek; i += 1) {
    dates.push({
      type: 'prevMonth',
      date: numDayInPrevMonth - startOfWeek + i + 1
    });
  }

  for (let i = 0; i < numDays; i += 1) {
    dates.push({
      type: 'currentMonth',
      date: i + 1
    });
  } // 6 rows x 7 cols


  const remainingDates = 42 - dates.length;

  for (let i = 0; i < remainingDates; i += 1) {
    dates.push({
      type: 'nextMonth',
      date: i + 1
    });
  }

  return dates;
}

const monthKeySelector = m => m.key;

const monthLabelSelector = m => m.label;

function Calendar(props) {
  const {
    className,
    dateRenderer: DateRenderer = CalendarDate$1,
    rendererParams,
    onDateClick,
    monthSelectionPopupClassName,
    initialDate,
    activeDate
  } = props;
  const today = new Date();
  const current = initialDate ? new Date(initialDate) : today;
  const currentYear = current.getFullYear();
  const currentMonth = current.getMonth();
  const [year, setYear] = useInputState(currentYear);
  const [month, setMonth] = useInputState(currentMonth);
  const dates = year ? getDates(year, month) : undefined;
  const handleGotoCurrentButtonClick = React.useCallback(() => {
    const date = new Date();
    setYear(date.getFullYear());
    setMonth(date.getMonth());
  }, [setMonth, setYear]);
  const handleNextMonthButtonClick = React.useCallback(() => {
    if (isDefined(year)) {
      const date = new Date(year, month + 1, 1);
      setYear(date.getFullYear());
      setMonth(date.getMonth());
    }
  }, [year, month, setMonth, setYear]);
  const handlePreviousMonthButtonClick = React.useCallback(() => {
    if (isDefined(year)) {
      const date = new Date(year, month - 1, 1);
      setYear(date.getFullYear());
      setMonth(date.getMonth());
    }
  }, [year, month, setMonth, setYear]);
  const isValidYear = React.useMemo(() => {
    if (isNotDefined(year)) {
      return false;
    }

    if (year < 1900 || year > 9999) {
      return false;
    }

    return true;
  }, [year]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$n.calendar, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$n.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$n.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$n.currentYear
  }, /*#__PURE__*/React.createElement(NumberInput, {
    type: "number",
    name: "calendar-year-input",
    onChange: setYear,
    value: year
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$n.currentMonth
  }, /*#__PURE__*/React.createElement(SelectInput, {
    name: "calendar-month-input",
    options: monthNameList,
    value: month,
    onChange: setMonth,
    keySelector: monthKeySelector,
    labelSelector: monthLabelSelector,
    nonClearable: true,
    optionsPopupClassName: _cs(monthSelectionPopupClassName, styles$n.monthSelectionPopup),
    optionsPopupContentClassName: styles$n.popupContent
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$n.weekDays
  }, map(weekDayNames).call(weekDayNames, wd => /*#__PURE__*/React.createElement("div", {
    key: wd,
    className: styles$n.weekDayName
  }, wd.substr(0, 2))))), isValidYear && isDefined(year) && dates ? /*#__PURE__*/React.createElement("div", {
    className: styles$n.dayList
  }, map(dates).call(dates, date => {
    let newMonth = month;

    if (date.type === 'prevMonth') {
      newMonth -= 1;
    } else if (date.type === 'nextMonth') {
      newMonth += 1;
    }

    const ymd = new Date(year, newMonth, date.date);
    const defaultProps = {
      onClick: onDateClick,
      year: ymd.getFullYear(),
      month: ymd.getMonth(),
      date: ymd.getDate(),
      currentYear: today.getFullYear(),
      currentMonth: today.getMonth(),
      currentDate: today.getDate(),
      activeDate,
      ghost: date.type === 'prevMonth' || date.type === 'nextMonth'
    };
    const combinedProps = { ...(rendererParams ? rendererParams(date.date, month, year) : undefined),
      ...defaultProps
    };
    const children = /*#__PURE__*/React.createElement(DateRenderer, combinedProps);
    return /*#__PURE__*/React.createElement("div", {
      className: styles$n.dayContainer,
      key: `${date.type}-${date.date}`
    }, children);
  })) : /*#__PURE__*/React.createElement("div", {
    className: styles$n.emptyDayList
  }, /*#__PURE__*/React.createElement(IoCalendarOutline, {
    className: styles$n.icon
  }), "Please select a valid year and month to view the dates"), /*#__PURE__*/React.createElement("div", {
    className: styles$n.actions
  }, /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    title: "Go to current year / month",
    transparent: true,
    onClick: handleGotoCurrentButtonClick
  }, /*#__PURE__*/React.createElement(IoTimeOutline, null)), /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    transparent: true,
    onClick: handlePreviousMonthButtonClick,
    title: "Previous month",
    disabled: isNotDefined(year)
  }, /*#__PURE__*/React.createElement(IoChevronBack, null)), /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    transparent: true,
    onClick: handleNextMonthButtonClick,
    title: "Next month",
    disabled: isNotDefined(year)
  }, /*#__PURE__*/React.createElement(IoChevronForward, null))));
}

var Calendar$1 = typedMemo(Calendar);

var styles$m = {"input":"styles_input__h6YJi","empty":"styles_empty__1-RbT","errored":"styles_errored__1TcKj","dark":"styles_dark__12f-o","calendarPopup":"styles_calendar-popup__5KgLu","popupContent":"styles_popup-content__eqovi","calendar":"styles_calendar__1XIi7"};

function DateInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    inputElementRef,
    containerRef: containerRefFromProps,
    inputSectionRef,
    inputClassName,
    onChange,
    name,
    value,
    ...dateInputProps
  } = props;
  const [calendarMonthSelectionPopupClassName] = React.useState(randomString(16));
  const createdContainerRef = React.useRef(null);
  const popupRef = React.useRef(null);
  const containerRef = containerRefFromProps !== null && containerRefFromProps !== void 0 ? containerRefFromProps : createdContainerRef;
  const [showCalendar, setShowCalendarTrue, setShowCalendarFalse,, toggleShowCalendar] = useBooleanState(false);
  const handlePopupBlur = React.useCallback((isClickedWithin, e) => {
    // Following is to prevent the popup blur when
    // month selection is changed in the calendar
    const container = document.getElementsByClassName(calendarMonthSelectionPopupClassName)[0];
    const isContainerOrInsideContainer = container ? container === e.target || container.contains(e.target) : false;

    if (!isClickedWithin && !isContainerOrInsideContainer) {
      setShowCalendarFalse();
    }
  }, [setShowCalendarFalse, calendarMonthSelectionPopupClassName]);
  useBlurEffect(showCalendar, handlePopupBlur, popupRef, containerRef);
  const handleCalendarDateClick = React.useCallback((year, month, day) => {
    if (onChange) {
      onChange(ymdToDateString(year, month, day), name, undefined);
    }

    setShowCalendarFalse();
  }, [name, onChange, setShowCalendarFalse]);
  const handleClearButtonClick = React.useCallback(() => {
    if (onChange) {
      onChange(undefined, name, undefined);
    }
  }, [onChange, name]);
  const handleRawInputClick = React.useCallback(e => {
    e.preventDefault();
    setShowCalendarTrue();
  }, [setShowCalendarTrue]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputContainer, {
    containerRef: containerRef,
    inputSectionRef: inputSectionRef,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !readOnly && /*#__PURE__*/React.createElement(React.Fragment, null, value && /*#__PURE__*/React.createElement(Button, {
      name: undefined,
      compact: true,
      transparent: true,
      onClick: handleClearButtonClick,
      disabled: disabled
    }, /*#__PURE__*/React.createElement(IoClose, null)), /*#__PURE__*/React.createElement(Button, {
      name: undefined,
      onClick: toggleShowCalendar,
      compact: true,
      transparent: true,
      disabled: disabled
    }, /*#__PURE__*/React.createElement(IoCalendarOutline, null)))),
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(RawInput, _extends({}, dateInputProps, {
      name: name,
      className: _cs(styles$m.input, !!error && styles$m.errored, !value && styles$m.empty, inputClassName),
      elementRef: inputElementRef // NOTE: Make this required to hide clear button on firefox
      ,
      required: !!value,
      readOnly: true,
      uiMode: uiMode,
      onClick: handleRawInputClick,
      disabled: disabled,
      value: value,
      onFocus: setShowCalendarTrue,
      type: "date"
    }))
  }), !readOnly && showCalendar && /*#__PURE__*/React.createElement(Popup, {
    parentRef: containerRef,
    elementRef: popupRef,
    className: styles$m.calendarPopup,
    contentClassName: styles$m.popupContent,
    freeWidth: true
  }, /*#__PURE__*/React.createElement(Calendar$1, {
    onDateClick: handleCalendarDateClick,
    className: styles$m.calendar,
    monthSelectionPopupClassName: calendarMonthSelectionPopupClassName,
    initialDate: value !== null && value !== void 0 ? value : undefined,
    activeDate: value !== null && value !== void 0 ? value : undefined
  })));
}

const predefinedDateRangeOptions = [{
  key: 'today',
  label: 'Today',
  getValue: () => ({
    startDate: new Date(),
    endDate: new Date()
  })
}, {
  key: 'yesterday',
  label: 'Yesterday',
  getValue: () => {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 1);
    const endDate = new Date();
    endDate.setDate(endDate.getDate() - 1);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'thisWeek',
  label: 'This week',
  getValue: () => {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - startDate.getDay());
    const endDate = new Date(); // NOTE: this will give us sunday

    endDate.setDate(startDate.getDate() + 6);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'lastSevenDays',
  label: 'Last 7 days',
  getValue: () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 7);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'thisMonth',
  label: 'This month',
  getValue: () => {
    const startDate = new Date();
    startDate.setDate(1);
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(0);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'lastThirtyDays',
  label: 'Last 30 days',
  getValue: () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 30);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'lastThreeMonths',
  label: 'Last 3 months',
  getValue: () => {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 2);
    startDate.setDate(1);
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(0);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'lastSixMonths',
  label: 'Last 6 months',
  getValue: () => {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 5);
    startDate.setDate(1);
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(0);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'thisYear',
  label: 'This year',
  getValue: () => {
    const startDate = new Date();
    startDate.setMonth(0);
    startDate.setDate(1);
    const endDate = new Date();
    endDate.setFullYear(startDate.getFullYear() + 1);
    endDate.setMonth(0);
    endDate.setDate(0);
    return {
      startDate,
      endDate
    };
  }
}, {
  key: 'lastYear',
  label: 'Last year',
  getValue: () => {
    const startDate = new Date();
    startDate.setFullYear(startDate.getFullYear() - 1);
    startDate.setMonth(0);
    startDate.setDate(1);
    const endDate = new Date();
    endDate.setMonth(0);
    endDate.setDate(0);
    return {
      startDate,
      endDate
    };
  }
}];

var styles$l = {"inputContainer":"styles_input-container__VoTVK","input":"styles_input__2xgyS","empty":"styles_empty__3O10B","errored":"styles_errored__3Mdqi","dark":"styles_dark__3-zu8","separator":"styles_separator__1UvTx","startDateInput":"styles_start-date-input__3pxQb","endDateInput":"styles_end-date-input__3-F5t","calendarPopup":"styles_calendar-popup__24UsJ","popupContent":"styles_popup-content__3O3r-","calendar":"styles_calendar__3bdq3","predefinedOptions":"styles_predefined-options__1dBAO","option":"styles_option__1rJ9C","calendarDate":"styles_calendar-date__R6mhA","startDate":"styles_start-date__36E9v","ghost":"styles_ghost__3yoY5","endDate":"styles_end-date__CCjTy","inBetween":"styles_in-between__-_rm7"};

function prevMonth(date) {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() - 1);
  return newDate;
}

function sameMonth(foo, bar) {
  return foo.getFullYear() === bar.getFullYear() && foo.getMonth() === bar.getMonth();
}

function DateRenderer(props) {
  const {
    className: dateClassName,
    year,
    month,
    date,
    startDate,
    endDate,
    ghost,
    ...otherProps
  } = props;
  const start = startDate ? dateStringToDate(startDate).getTime() : undefined;
  const end = endDate ? dateStringToDate(endDate).getTime() : undefined;
  const current = new Date(year, month, date).getTime();
  const inBetween = isDefined(start) && isDefined(end) && current > start && current < end;
  const dateString = ymdToDateString(year, month, date);
  const isEndDate = dateString === endDate;
  const isStartDate = dateString === startDate;
  return /*#__PURE__*/React.createElement(CalendarDate$1, _extends({}, otherProps, {
    className: _cs(styles$l.calendarDate, dateClassName, isStartDate && styles$l.startDate, isEndDate && styles$l.endDate, inBetween && styles$l.inBetween, ghost && styles$l.ghost),
    year: year,
    month: month,
    date: date,
    ghost: ghost
  }));
}

function DateRangeInput(props) {
  var _tempDate$startDate2, _tempDate$startDate3, _tempDate$startDate4;

  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    inputElementRef,
    containerRef: containerRefFromProps,
    inputSectionRef,
    inputClassName,
    onChange,
    name,
    value
  } = props;
  const [tempDate, setTempDate] = React.useState({
    startDate: undefined,
    endDate: undefined
  });
  const [calendarMonthSelectionPopupClassName] = React.useState(randomString(16));
  const createdContainerRef = React.useRef(null);
  const popupRef = React.useRef(null);
  const containerRef = containerRefFromProps !== null && containerRefFromProps !== void 0 ? containerRefFromProps : createdContainerRef;
  const [showCalendar, setShowCalendarTrue, setShowCalendarFalse,, toggleShowCalendar] = useBooleanState(false);
  const hideCalendar = React.useCallback(() => {
    setTempDate({
      startDate: undefined,
      endDate: undefined
    });
    setShowCalendarFalse();
  }, [setShowCalendarFalse]);
  const handlePopupBlur = React.useCallback((isClickedWithin, e) => {
    // Following is to prevent the popup blur when
    // month selection is changed in the calendar
    const container = document.getElementsByClassName(calendarMonthSelectionPopupClassName)[0];
    const isContainerOrInsideContainer = container ? container === e.target || container.contains(e.target) : false;

    if (!isClickedWithin && !isContainerOrInsideContainer) {
      hideCalendar();
    }
  }, [hideCalendar, calendarMonthSelectionPopupClassName]);
  useBlurEffect(showCalendar, handlePopupBlur, popupRef, containerRef);
  const dateRendererParams = React.useCallback(() => {
    var _tempDate$startDate;

    return {
      startDate: (_tempDate$startDate = tempDate.startDate) !== null && _tempDate$startDate !== void 0 ? _tempDate$startDate : value === null || value === void 0 ? void 0 : value.startDate,
      // we only set end date if user hasn't set the start date
      // i.e. to show previously selected end date)
      endDate: !tempDate.startDate ? value === null || value === void 0 ? void 0 : value.endDate : undefined
    };
  }, [tempDate.startDate, value]);
  const handleCalendarDateClick = React.useCallback((year, month, day) => {
    setTempDate(prevTempDate => {
      if (isDefined(prevTempDate.startDate)) {
        const lastDate = ymdToDateString(year, month, day);
        const prev = dateStringToDate(prevTempDate.startDate).getTime();
        const current = new Date(year, month, day).getTime();
        const startDate = prev > current ? lastDate : prevTempDate.startDate;
        const endDate = prev > current ? prevTempDate.startDate : lastDate;
        return {
          startDate,
          endDate
        };
      }

      return {
        startDate: ymdToDateString(year, month, day),
        endDate: undefined
      };
    });
  }, []);
  React.useEffect(() => {
    if (isDefined(tempDate.endDate)) {
      if (onChange) {
        onChange(tempDate, name);
      }

      hideCalendar();
    }
  }, [tempDate, hideCalendar, onChange, name]);
  const handlePredefinedOptionClick = React.useCallback(optionKey => {
    if (onChange) {
      const option = find(predefinedDateRangeOptions).call(predefinedDateRangeOptions, d => d.key === optionKey);

      if (option) {
        const {
          startDate,
          endDate
        } = option.getValue();
        onChange({
          startDate: ymdToDateString(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()),
          endDate: ymdToDateString(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
        }, name);
      }
    }

    hideCalendar();
  }, [onChange, hideCalendar, name]);
  const handleClearButtonClick = React.useCallback(() => {
    if (onChange) {
      onChange(undefined, name);
    }
  }, [onChange, name]);
  const endDate = value === null || value === void 0 ? void 0 : value.endDate;
  const endDateDate = endDate ? dateStringToDate(endDate) : new Date();
  const startDate = value === null || value === void 0 ? void 0 : value.startDate;
  let startDateDate = startDate ? dateStringToDate(startDate) : new Date();

  if (sameMonth(endDateDate, startDateDate)) {
    startDateDate = prevMonth(startDateDate);
  }

  const firstInitialDate = ymdToDateString(startDateDate.getFullYear(), startDateDate.getMonth(), 1);
  const secondInitialDate = ymdToDateString(endDateDate.getFullYear(), endDateDate.getMonth(), 1);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputContainer, {
    containerRef: containerRef,
    inputSectionRef: inputSectionRef,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !readOnly && /*#__PURE__*/React.createElement(React.Fragment, null, value && /*#__PURE__*/React.createElement(Button, {
      name: undefined,
      compact: true,
      transparent: true,
      onClick: handleClearButtonClick,
      disabled: disabled,
      title: "Clear"
    }, /*#__PURE__*/React.createElement(IoClose, null)), /*#__PURE__*/React.createElement(Button, {
      name: undefined,
      compact: true,
      transparent: true,
      onClick: toggleShowCalendar,
      disabled: disabled,
      title: "Show calendar"
    }, /*#__PURE__*/React.createElement(IoCalendarOutline, null)))),
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    inputContainerClassName: styles$l.inputContainer,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RawInput, {
      name: "startDate",
      className: _cs(styles$l.input, styles$l.startDateInput, !!error && styles$l.errored, !((_tempDate$startDate2 = tempDate.startDate) !== null && _tempDate$startDate2 !== void 0 ? _tempDate$startDate2 : value === null || value === void 0 ? void 0 : value.startDate) && styles$l.empty, inputClassName),
      value: (_tempDate$startDate3 = tempDate.startDate) !== null && _tempDate$startDate3 !== void 0 ? _tempDate$startDate3 : value === null || value === void 0 ? void 0 : value.startDate // NOTE: Make this required to hide clear button on firefox
      ,
      required: !!((_tempDate$startDate4 = tempDate.startDate) !== null && _tempDate$startDate4 !== void 0 ? _tempDate$startDate4 : value === null || value === void 0 ? void 0 : value.startDate),
      elementRef: inputElementRef,
      readOnly: true,
      uiMode: uiMode,
      disabled: disabled,
      onFocus: setShowCalendarTrue,
      type: "date"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$l.separator
    }, "to"), /*#__PURE__*/React.createElement(RawInput, {
      name: "startDate",
      className: _cs(styles$l.input, styles$l.endDateInput, !!error && styles$l.errored, !(value !== null && value !== void 0 && value.endDate) && styles$l.empty, inputClassName),
      elementRef: inputElementRef,
      readOnly: true,
      onClick: setShowCalendarTrue // NOTE: Make this required to hide clear button on firefox
      ,
      required: !!(value !== null && value !== void 0 && value.endDate),
      value: value === null || value === void 0 ? void 0 : value.endDate,
      uiMode: uiMode,
      disabled: disabled,
      onFocus: setShowCalendarTrue,
      type: "date"
    }))
  }), !readOnly && showCalendar && /*#__PURE__*/React.createElement(Popup, {
    parentRef: containerRef,
    elementRef: popupRef,
    freeWidth: true,
    className: styles$l.calendarPopup,
    contentClassName: styles$l.popupContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.predefinedOptions
  }, map(predefinedDateRangeOptions).call(predefinedDateRangeOptions, opt => /*#__PURE__*/React.createElement(RawButton, {
    className: styles$l.option,
    key: opt.key,
    name: opt.key,
    onClick: handlePredefinedOptionClick
  }, opt.label))), /*#__PURE__*/React.createElement(Calendar$1, {
    onDateClick: handleCalendarDateClick,
    className: styles$l.calendar,
    monthSelectionPopupClassName: calendarMonthSelectionPopupClassName,
    dateRenderer: DateRenderer,
    rendererParams: dateRendererParams,
    initialDate: firstInitialDate
  }), /*#__PURE__*/React.createElement(Calendar$1, {
    onDateClick: handleCalendarDateClick,
    className: styles$l.calendar,
    monthSelectionPopupClassName: calendarMonthSelectionPopupClassName,
    dateRenderer: DateRenderer,
    rendererParams: dateRendererParams,
    initialDate: secondInitialDate
  })));
}

function DateRangeDualInput(props) {
  const {
    fromName,
    toName,
    fromValue,
    toValue,
    fromOnChange,
    toOnChange,
    fromError,
    toError,
    ...otherProps
  } = props;
  const value = useMemo(() => fromValue && toValue ? {
    startDate: fromValue,
    endDate: toValue
  } : undefined, [toValue, fromValue]);
  const handleValueChange = useCallback(newVal => {
    if (fromOnChange) {
      fromOnChange(newVal === null || newVal === void 0 ? void 0 : newVal.startDate, fromName);
    }

    if (toOnChange) {
      toOnChange(newVal === null || newVal === void 0 ? void 0 : newVal.endDate, toName);
    }
  }, [toOnChange, fromOnChange, toName, fromName]);
  const error = useMemo(() => {
    var _context;

    const errors = filter(_context = [toError, fromError]).call(_context, isDefined);

    return errors.length > 0 ? errors.join(', ') : undefined;
  }, [toError, fromError]);
  return /*#__PURE__*/React.createElement(DateRangeInput, _extends({
    name: undefined,
    value: value,
    onChange: handleValueChange,
    error: error
  }, otherProps));
}

const datetimeFormatter = new Intl.DateTimeFormat('default', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
});
const dateFormatter = new Intl.DateTimeFormat('default', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
});

function DateTime(props) {
  const {
    value,
    className,
    format = 'date'
  } = props;

  if (isNotDefined(value)) {
    return null;
  }

  const date = Date.parse(value);
  const formatter = format === 'datetime' ? datetimeFormatter : dateFormatter;
  const dateString = formatter.format(date);
  return /*#__PURE__*/React.createElement("time", {
    dateTime: value,
    className: className
  }, dateString);
}

function DateTimeInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    onChange,
    name,
    ...rawInputProps
  } = props;
  const handleNowSet = useCallback(() => {
    if (!onChange) {
      return;
    }

    const value = new Date().toISOString().substr(0, 16);
    onChange(value, name, undefined);
  }, [onChange, name]);
  return /*#__PURE__*/React.createElement(InputContainer, {
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(RawInput, _extends({}, rawInputProps, {
      name: name,
      onChange: onChange,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      type: "datetime-local"
    })),
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !readOnly && /*#__PURE__*/React.createElement(Button, {
      onClick: handleNowSet,
      disabled: disabled,
      transparent: true,
      compact: true,
      uiMode: uiMode,
      name: undefined,
      title: "Set now"
    }, /*#__PURE__*/React.createElement(IoMdTime, null)))
  });
}

var styles$k = {"dateTimeRange":"styles_date-time-range__1QjiI","to":"styles_to__2KVsi"};

function DateTimeRange(props) {
  const {
    className,
    from,
    to,
    dateTimeClassName,
    format
  } = props;

  if (isNotDefined(from) && isNotDefined(to)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: _cs(styles$k.dateTimeRange, className)
  }, /*#__PURE__*/React.createElement(DateTime, {
    className: _cs(styles$k.dateTimeClassName, dateTimeClassName),
    value: from,
    format: format
  }), isDefined(from) && isDefined(to) && /*#__PURE__*/React.createElement("span", {
    className: styles$k.to
  }, "to"), /*#__PURE__*/React.createElement(DateTime, {
    className: _cs(styles$k.dateTimeClassName, dateTimeClassName),
    value: to,
    format: format
  }));
}

var styles$j = {"button":"styles_button__167cU","roundButton":"styles_round-button__2RsY0","children":"styles_children__lpx0C"};

function QuickActionButton(props) {
  const {
    className,
    childrenContainerClassName,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: _cs(className, styles$j.button, styles$j.roundButton),
    childrenContainerClassName: _cs(styles$j.children, childrenContainerClassName),
    variant: "default"
  }, otherProps));
}

var styles$i = {"pendingAnimation":"styles_pending-animation__2YSSG","twinkle":"styles_twinkle__yUli_","circle":"styles_circle__1kizR","innerCircle":"styles_inner-circle__3NOmX"};

function Circle() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$i.circle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$i.innerCircle
  }));
}

function PendingAnimation(props) {
  const {
    className
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$i.pendingAnimation, className)
  }, /*#__PURE__*/React.createElement(Circle, null), /*#__PURE__*/React.createElement(Circle, null), /*#__PURE__*/React.createElement(Circle, null));
}

var styles$h = {"pendingMessage":"styles_pending-message__1CQ2W","appear":"styles_appear__1GjNd"};

function PendingMessage(props) {
  const {
    className,
    message = 'Please wait...'
  } = props;
  return /*#__PURE__*/React.createElement(Cover, {
    className: _cs(styles$h.pendingMessage, className)
  }, /*#__PURE__*/React.createElement(PendingAnimation, null), /*#__PURE__*/React.createElement("div", {
    className: styles$h.message
  }, message));
}

var styles$g = {"message":"styles_message__AyABk","iconContainer":"styles_icon-container__2PzJE","compact":"styles_compact__1yc4k","vertical":"styles_vertical__zNgjk","actions":"styles_actions__3-os-"};

const genericMemo = memo;

function Message(props) {
  const {
    className,
    pending,
    empty,
    filtered,
    errored,
    message: messageFromProps,
    pendingMessage,
    emptyMessage = 'No data available',
    filteredEmptyMessage = 'No matching data',
    erroredEmptyMessage = 'Oops! We ran into an issue',
    pendingContainerClassName,
    compact,
    compactPendingMessage,
    compactEmptyMessage,
    compactAndVertical,
    messageHidden = false,
    onReload,
    actions,
    actionsContainerClassName
  } = props;

  if (pending) {
    return /*#__PURE__*/React.createElement(PendingMessage, {
      className: pendingContainerClassName,
      message: pendingMessage,
      compact: compactPendingMessage || compact
    });
  }

  let message = messageFromProps;

  if (empty || errored) {
    if (errored) {
      message = erroredEmptyMessage;
    } else if (filtered) {
      message = filteredEmptyMessage;
    } else {
      message = emptyMessage;
    }
  }

  if (!message) {
    return null;
  }

  const showActions = errored && onReload || actions;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles$g.message, (compactAndVertical || compact || compactEmptyMessage) && styles$g.compact, compactAndVertical && styles$g.vertical)
  }, !messageHidden && /*#__PURE__*/React.createElement("div", {
    className: styles$g.content
  }, message), showActions && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$g.actions, actionsContainerClassName)
  }, onReload && compact && /*#__PURE__*/React.createElement(QuickActionButton, {
    name: undefined,
    onClick: onReload,
    variant: "primary"
  }, /*#__PURE__*/React.createElement(IoRefreshOutline, null)), onReload && !compact && /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    onClick: onReload,
    variant: "default",
    icons: /*#__PURE__*/React.createElement(IoRefreshOutline, null)
  }, "Reload"), actions));
}

var index = genericMemo(Message);

var styles$f = {"option":"styles_option__1r7SD","active":"styles_active__Z3e74","icon":"styles_icon__12EeO","label":"styles_label__3ylHE"};

function Option(props) {
  const {
    children,
    isActive
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$f.icon
  }, isActive ? /*#__PURE__*/React.createElement(MdCheckBox, null) : /*#__PURE__*/React.createElement(MdCheckBoxOutlineBlank, null)), /*#__PURE__*/React.createElement("div", {
    className: styles$f.label
  }, children));
}

const emptyList = [];

function SearchMultiSelectInput(props) {
  const {
    keySelector,
    labelSelector,
    name,
    onChange,
    onOptionsChange,
    options: optionsFromProps,
    optionsPending,
    value: valueFromProps,
    sortFunction,
    searchOptions: searchOptionsFromProps,
    onSearchValueChange,
    onShowDropdownChange,
    ...otherProps
  } = props;
  const options = optionsFromProps !== null && optionsFromProps !== void 0 ? optionsFromProps : emptyList;
  const searchOptions = searchOptionsFromProps !== null && searchOptionsFromProps !== void 0 ? searchOptionsFromProps : emptyList;
  const value = valueFromProps !== null && valueFromProps !== void 0 ? valueFromProps : emptyList;
  const [searchInputValue, setSearchInputValue] = React.useState('');
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [focused, setFocused] = React.useState(false);
  const [focusedKey, setFocusedKey] = React.useState();
  const [selectedKeys, setSelectedKeys] = useState({});
  const optionsMap = useMemo(() => listToMap(options, keySelector, i => i), [options, keySelector]);
  const optionsLabelMap = useMemo(() => listToMap(options, keySelector, labelSelector), [options, keySelector, labelSelector]);
  const valueDisplay = useMemo(() => map(value).call(value, v => {
    var _optionsLabelMap$v;

    return (_optionsLabelMap$v = optionsLabelMap[v]) !== null && _optionsLabelMap$v !== void 0 ? _optionsLabelMap$v : '?';
  }).join(', '), [value, optionsLabelMap]); // NOTE: we can skip this calculation if optionsShowInitially is false

  const selectedOptions = useMemo(() => {
    var _context;

    return filter(_context = map(value).call(value, valueKey => optionsMap[valueKey])).call(_context, isDefined);
  }, [value, optionsMap]);
  const realOptions = useMemo(() => {
    const allOptions = unique([...searchOptions, ...selectedOptions], keySelector);

    const initiallySelected = filter(allOptions).call(allOptions, item => selectedKeys[keySelector(item)]);

    const initiallyNotSelected = filter(allOptions).call(allOptions, item => !selectedKeys[keySelector(item)]);

    if (sortFunction) {
      return [...rankedSearchOnList(initiallySelected, searchInputValue, labelSelector), ...sortFunction(initiallyNotSelected, searchInputValue, labelSelector)];
    }

    return [...rankedSearchOnList(initiallySelected, searchInputValue, labelSelector), ...initiallyNotSelected];
  }, [keySelector, labelSelector, searchInputValue, searchOptions, selectedKeys, selectedOptions, sortFunction]);
  const handleSearchValueChange = useCallback(searchValue => {
    setSearchInputValue(searchValue);

    if (onSearchValueChange) {
      onSearchValueChange(searchValue);
    }
  }, [onSearchValueChange]);
  const handleChangeDropdown = useCallback(myVal => {
    setShowDropdown(myVal);

    if (onShowDropdownChange) {
      onShowDropdownChange(myVal);
    }

    if (myVal) {
      setSelectedKeys(listToMap(value, item => item, () => true));
      setFocusedKey(undefined);
    } else {
      setSelectedKeys({});
      setFocusedKey(undefined);
      setSearchInputValue('');

      if (onSearchValueChange) {
        onSearchValueChange('');
      }
    }
  }, [value, onSearchValueChange, onShowDropdownChange]);
  const optionRendererParams = useCallback((key, option) => {
    const isActive = findIndex(value).call(value, item => item === key) !== -1;
    return {
      children: labelSelector(option),
      containerClassName: _cs(styles$f.option, isActive && styles$f.active),
      title: labelSelector(option),
      isActive
    };
  }, [labelSelector, value]); // FIXME: value should not be on dependency list, also try to pass options like in SelectInput

  const handleOptionClick = useCallback((k, v) => {
    const newValue = [...value];

    const optionKeyIndex = findIndex(value).call(value, d => d === k);

    if (optionKeyIndex !== -1) {
      splice(newValue).call(newValue, optionKeyIndex, 1);
    } else {
      newValue.push(k);

      if (onOptionsChange) {
        onOptionsChange(existingOptions => {
          const safeOptions = existingOptions !== null && existingOptions !== void 0 ? existingOptions : [];

          const opt = find(safeOptions).call(safeOptions, item => keySelector(item) === k);

          if (opt) {
            return existingOptions;
          }

          return [...safeOptions, v];
        });
      }
    }

    onChange(newValue, name);
  }, [value, onChange, name, onOptionsChange, keySelector]);
  const handleClear = useCallback(() => {
    onChange([], name);
  }, [name, onChange]);
  return /*#__PURE__*/React.createElement(SelectInputContainer, _extends({}, otherProps, {
    name: name,
    options: realOptions,
    optionsPending: optionsPending,
    optionsFiltered: (searchInputValue === null || searchInputValue === void 0 ? void 0 : searchInputValue.length) > 0,
    optionKeySelector: keySelector,
    optionRenderer: Option,
    optionRendererParams: optionRendererParams,
    optionContainerClassName: styles$f.optionContainer,
    onOptionClick: handleOptionClick,
    valueDisplay: valueDisplay,
    onClear: handleClear,
    searchText: searchInputValue,
    onSearchTextChange: handleSearchValueChange,
    dropdownShown: showDropdown,
    onDropdownShownChange: handleChangeDropdown,
    focused: focused,
    onFocusedChange: setFocused,
    focusedKey: focusedKey,
    onFocusedKeyChange: setFocusedKey,
    persistentOptionPopup: true,
    nonClearable: false,
    hasValue: isDefined(value) && value.length > 0
  }));
}

// eslint-disable-next-line @typescript-eslint/ban-types
function MultiSelectInput(props) {
  const {
    name,
    options,
    totalOptionsCount,
    // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(SearchMultiSelectInput, _extends({}, otherProps, {
    name: name,
    options: options,
    sortFunction: rankedSearchOnList,
    searchOptions: options
  }));
}

var log = Math.log;
var LOG10E = Math.LOG10E;

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
_export({ target: 'Math', stat: true }, {
  log10: function log10(x) {
    return log(x) * LOG10E;
  }
});

var log10$1 = path.Math.log10;

var log10 = log10$1;

var trim = stringTrim.trim;


var $parseFloat = global_1.parseFloat;
var FORCED$1 = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$1 ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
_export({ target: 'Number', stat: true, forced: Number.parseFloat != numberParseFloat }, {
  parseFloat: numberParseFloat
});

var _parseFloat$1 = path.Number.parseFloat;

var _parseFloat = _parseFloat$1;

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
_export({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});

var isNan$1 = path.Number.isNaN;

var isNan = isNan$1;

var styles$e = {"placeholder":"styles_placeholder__3Ub7O"};

function getAutoPrecision(value, largeNumber, defaultPrecision) {
  if (isNotDefined(value) || value === 0) {
    return 0;
  }

  const absoluteValue = Math.abs(value);

  if (absoluteValue < 1) {
    // NOTE: the value is hardcoded here
    return Math.ceil(-log10(absoluteValue)) + 1;
  } // NOTE: ignore precision for large numbers


  if (absoluteValue > largeNumber) {
    return 0;
  }

  return defaultPrecision;
}

function formatNumberRaw(value, separator, abbreviate, precision) {
  if (isNotDefined(value)) {
    return undefined;
  }

  const sanitizedValue = _parseFloat(String(value));

  if (isNan(sanitizedValue)) {
    return undefined;
  }

  let output = '';
  let suffix;

  if (abbreviate) {
    const {
      number,
      normalizeSuffix
    } = formattedNormalize(sanitizedValue, Lang.en);
    suffix = normalizeSuffix; // NOTE: the value is hardcoded here

    output = isTruthyString(suffix) ? number.toFixed(1) : number.toFixed(precision);
  } else {
    output = sanitizedValue.toFixed(precision);
  } // TODO: do not hardcode decimal symbol


  const indexOfDecimal = indexOf$1(output).call(output, '.');

  if (indexOfDecimal !== -1) {
    if (/\.0+$/.test(output)) {
      // Remove all trailing zeros starting immediately after decimal
      output = output.substr(0, indexOfDecimal);
    } else {
      // Remove trailing zeros after decimal
      output = output.replace(/(\.\d*[1-9]+)0+/, '$1');
    }
  }

  if (isTruthyString(separator)) {
    output = addSeparator(output, separator);
  }

  return {
    value: output,
    valueSuffix: suffix
  };
}

/**
 * Number formatting component
 */
function Numeral({
  value,
  precision = -1,
  className,
  abbreviate,
  separator = ',',
  prefix = '',
  suffix = '',
  placeholder = '',
  prefixClassName,
  valueClassName,
  suffixClassName,
  abbrClassName,
  largeNumber = 100,
  defaultPrecision = 2
}) {
  const fallback = isTruthyString(placeholder) ? /*#__PURE__*/React.createElement("span", {
    className: _cs(className, styles$e.placeholder)
  }, placeholder) : null;

  if (isNotDefined(value)) {
    return fallback;
  }

  const precise = precision < 0 ? getAutoPrecision(value, largeNumber, defaultPrecision) : precision;
  const output = formatNumberRaw(value, separator, abbreviate, precise);

  if (isNotDefined(output)) {
    return fallback;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, prefix && /*#__PURE__*/React.createElement("span", {
    className: prefixClassName
  }, prefix), /*#__PURE__*/React.createElement("span", {
    className: valueClassName
  }, output.value), isTruthyString(output.valueSuffix) && /*#__PURE__*/React.createElement("span", {
    className: abbrClassName
  }, output.valueSuffix), suffix && /*#__PURE__*/React.createElement("span", {
    className: suffixClassName
  }, suffix));
}

var defineProperty$1 = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty$1);

// THIS FILE IS AUTO GENERATED
function FaChevronLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"}}]})(props);
}function FaChevronRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"}}]})(props);
}function FaGreaterThanEqual (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
}function FaGripVertical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"}}]})(props);
}function FaLessThanEqual (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"}}]})(props);
}function FaSearch (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"}}]})(props);
}function FaSortDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"}}]})(props);
}function FaSortUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"}}]})(props);
}function FaSort (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"}}]})(props);
}

var styles$d = {"pager":"styles_pager__3iwpI","pageList":"styles_page-list__2zBQa","pageButton":"styles_page-button__2cAqw","active":"styles_active__17YY8","pageSpan":"styles_page-span__Kv6q6","infoAndConfig":"styles_info-and-config__3j-ui","itemsPerPage":"styles_items-per-page__2FZCH","input":"styles_input__3Oes4","currentRangeInformation":"styles_current-range-information__36g1E","showing":"styles_showing__1J82R","range":"styles_range__1qA1v","from":"styles_from__17Tq5","to":"styles_to__zCcj5","separator":"styles_separator__1p0aW","of":"styles_of__11pwO","perPageOptionPopup":"styles_per-page-option-popup__36L3s"};

function range(start, end) {
  const foo = [];

  for (let i = start; i <= end; i += 1) {
    foo.push(i);
  }

  return foo;
}

class Side {
  constructor(capacity, demand) {
    _defineProperty(this, "capacity", void 0);

    _defineProperty(this, "demand", void 0);

    _defineProperty(this, "excess", void 0);

    this.capacity = capacity;
    this.demand = demand;
    this.excess = this.capacity - this.demand;
  }

  hasShortage() {
    return this.excess < 0;
  }

  increaseCapacity(inc) {
    this.capacity += inc;
    this.excess += inc;
  }

  decreaseCapacity(dec) {
    this.capacity += dec;
    this.excess += dec;
  }

  optimizeCapacity() {
    if (this.excess > 0) {
      this.capacity -= this.excess;
      this.excess = 0;
    }
  }

}

function pagination(totalCapacity, active, total) {
  const oneSideCapacity = (totalCapacity - 1) / 2;
  const startIndex = 1;
  const lastIndex = total; // Once upon a time, there were two sides of a town
  // And every year, each got equal amount of ration
  // But, they had a variable demand, and each year it could change

  const right = new Side(oneSideCapacity, active - startIndex);
  const left = new Side(oneSideCapacity, lastIndex - active); // So the two sides made a treaty
  // If any of the side had an excess that year and the other side had a shortage,
  // they had to give the excess to the other side
  // Thay way, all the ration would be used

  const leftExcess = left.excess;
  const rightExcess = right.excess;

  if (right.hasShortage() && leftExcess > 0) {
    right.increaseCapacity(leftExcess);
  } else if (left.hasShortage() && right.excess > 0) {
    left.increaseCapacity(rightExcess);
  }

  left.optimizeCapacity();
  right.optimizeCapacity();
  const lst = [];

  if (right.capacity > 0) {
    if (right.excess >= 0) {
      var _context;

      lst.push(...map(_context = range(startIndex, active - 1)).call(_context, i => ({
        type: 'button',
        index: i
      })));
    } else {
      var _context2;

      lst.push({
        type: 'button',
        index: startIndex
      }, {
        type: 'span',
        label: '…',
        key: 'startTick'
      }, ...map(_context2 = range(active - (right.capacity - 2), active - 1)).call(_context2, i => ({
        type: 'button',
        index: i
      })));
    }
  }

  lst.push({
    type: 'fakeButton',
    label: String(active),
    key: 'active'
  });

  if (left.capacity > 0) {
    if (left.excess >= 0) {
      var _context3;

      lst.push(...map(_context3 = range(active + 1, lastIndex)).call(_context3, i => ({
        type: 'button',
        index: i
      })));
    } else {
      var _context4;

      lst.push(...map(_context4 = range(active + 1, active + (left.capacity - 2))).call(_context4, i => ({
        type: 'button',
        index: i
      })), {
        type: 'span',
        label: '...',
        key: 'endTick'
      }, {
        type: 'button',
        index: lastIndex
      });
    }
  }

  return lst;
}

const defaultOptions = [{
  label: '5 / page',
  key: 5
}, {
  label: '10 / page',
  key: 10
}, {
  label: '25 / page',
  key: 25
}, {
  label: '50 / page',
  key: 50
}, {
  label: '75 / page',
  key: 75
}, {
  label: '100 / page',
  key: 100
}];

function Pager(props) {
  const {
    activePage: activePageProps,
    className,
    itemsCount,
    onActivePageChange,
    options,
    maxItemsPerPage = 25,
    totalCapacity = 7,
    disabled = false,
    infoHidden,
    showLabel,
    popupClassName
  } = props;
  const showingTitle = 'Showing';
  const ofTitle = 'of';
  const rangeIndicator = '-'; // NOTE: activePage can never be 0

  const activePage = Math.max(activePageProps, 1); // NOTE: number of pages can never be 0

  const numPages = Math.max(Math.ceil(itemsCount / maxItemsPerPage), 1);
  const offset = (activePage - 1) * maxItemsPerPage;
  const itemsOnPage = Math.min(maxItemsPerPage, itemsCount - offset);
  const currentItemsStart = itemsOnPage > 0 ? offset + 1 : offset;
  const currentItemsEnd = offset + itemsOnPage;
  const pages = pagination(totalCapacity, activePage, numPages);
  const pageList = pages.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: styles$d.pageList
  }, /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    className: styles$d.pageButton,
    onClick: () => onActivePageChange(activePage - 1),
    disabled: activePage <= 1 || disabled,
    icons: /*#__PURE__*/React.createElement(FaChevronLeft, null),
    transparent: true
  }, showLabel && 'Prev'), map(pages).call(pages, page => {
    if (page.type === 'button') {
      return /*#__PURE__*/React.createElement(Button, {
        key: `button-${page.index}`,
        name: undefined,
        onClick: () => onActivePageChange(page.index),
        className: styles$d.pageButton,
        disabled: disabled,
        transparent: true
      }, page.index);
    }

    if (page.type === 'fakeButton') {
      return /*#__PURE__*/React.createElement(Button, {
        key: `button-${page.key}`,
        variant: "accent",
        name: undefined,
        className: _cs(styles$d.pageButton, styles$d.active),
        transparent: true
      }, page.label);
    }

    return /*#__PURE__*/React.createElement("div", {
      key: `span-${page.key}`,
      className: styles$d.pageSpan
    }, page.label);
  }), /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    onClick: () => onActivePageChange(activePage + 1),
    disabled: activePage >= numPages || disabled,
    className: styles$d.pageButton,
    actions: /*#__PURE__*/React.createElement(FaChevronRight, null),
    transparent: true
  }, showLabel && 'Next'));
  const info = !infoHidden && itemsCount > maxItemsPerPage && /*#__PURE__*/React.createElement("div", {
    className: styles$d.currentRangeInformation
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$d.showing
  }, showingTitle), /*#__PURE__*/React.createElement("div", {
    className: styles$d.range
  }, /*#__PURE__*/React.createElement(Numeral, {
    className: styles$d.from,
    value: currentItemsStart
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$d.separator
  }, rangeIndicator), /*#__PURE__*/React.createElement(Numeral, {
    className: styles$d.to,
    value: currentItemsEnd
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$d.of
  }, ofTitle), /*#__PURE__*/React.createElement(Numeral, {
    className: styles$d.total,
    value: itemsCount
  }));
  const itemsPerPageOptions = options !== null && options !== void 0 ? options : defaultOptions;
  const minOption = Math.min(0, ...map(itemsPerPageOptions).call(itemsPerPageOptions, opt => opt.key));
  const itemPerPageControl = !props.itemsPerPageControlHidden && itemsCount > minOption && /*#__PURE__*/React.createElement("div", {
    className: styles$d.itemsPerPage
  }, /*#__PURE__*/React.createElement(SelectInput, {
    name: "itemsPerPageSelection",
    className: styles$d.input,
    options: itemsPerPageOptions,
    keySelector: item => item.key,
    labelSelector: item => item.label,
    value: maxItemsPerPage,
    onChange: props.onItemsPerPageChange,
    disabled: disabled,
    optionsPopupClassName: _cs(styles$d.perPageOptionPopup, popupClassName),
    nonClearable: true
  }));

  if (!pageList && !itemPerPageControl && !info) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: _cs(className, styles$d.pager)
  }, pageList, (info || itemPerPageControl) && /*#__PURE__*/React.createElement("div", {
    className: styles$d.infoAndConfig
  }, info, itemPerPageControl));
}

var styles$c = {"passwordInput":"styles_password-input__2t-FN","showPasswordToggleButton":"styles_show-password-toggle-button__2QtV3"};

function PasswordInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    ...rawInputProps
  } = props;
  const [showPassword, setShowPassword] = React.useState(false);
  return /*#__PURE__*/React.createElement(InputContainer, {
    actionsContainerClassName: actionsContainerClassName,
    className: _cs(styles$c.passwordInput, className),
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, /*#__PURE__*/React.createElement(ToggleButton, {
      value: showPassword,
      onChange: setShowPassword,
      className: styles$c.showPasswordToggleButton,
      disabled: disabled,
      transparent: true,
      uiMode: uiMode,
      compact: true,
      name: undefined,
      title: showPassword ? 'Hide password' : 'Show password'
    }, showPassword ? /*#__PURE__*/React.createElement(IoMdEyeOff, null) : /*#__PURE__*/React.createElement(IoMdEye, null))),
    input: /*#__PURE__*/React.createElement(RawInput // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, rawInputProps, {
      uiMode: uiMode,
      readOnly: readOnly,
      disabled: disabled,
      type: showPassword ? 'text' : 'password'
    }))
  });
}

var styles$b = {"popup":"styles_popup__3t_Tv","popupContent":"styles_popup-content__3FtbP"};

function PopupButton(props) {
  const {
    popupClassName,
    popupContentClassName,
    children,
    label,
    name,
    actions,
    componentRef,
    arrowHidden,
    ...otherProps
  } = props;
  const buttonRef = React.useRef(null);
  const popupRef = React.useRef(null);
  const [popupShown, setPopupShown] = React.useState(false);
  useEffect(() => {
    if (componentRef) {
      componentRef.current = {
        setPopupVisibility: setPopupShown
      };
    }
  }, [componentRef]);
  useBlurEffect(popupShown, setPopupShown, popupRef, buttonRef);
  const handleShowPopup = useCallback(() => {
    setPopupShown(true);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    name: name,
    elementRef: buttonRef,
    onClick: handleShowPopup,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !arrowHidden && /*#__PURE__*/React.createElement(React.Fragment, null, popupShown ? /*#__PURE__*/React.createElement(IoIosArrowUp, null) : /*#__PURE__*/React.createElement(IoIosArrowDown, null)))
  }), label), popupShown && /*#__PURE__*/React.createElement(Popup, {
    elementRef: popupRef,
    parentRef: buttonRef,
    className: _cs(styles$b.popup, popupClassName),
    contentClassName: _cs(styles$b.popupContent, popupContentClassName)
  }, children));
}

var styles$a = {"radio":"styles_radio__3L7Rw","icons":"styles_icons__NpcM9","content":"styles_content__20Ebk","icon":"styles_icon__35QIS","input":"styles_input__2W_rP","active":"styles_active__QTCYH","disabled":"styles_disabled__1uhBn","readOnly":"styles_read-only__L9fkx"};

function Radio(props) {
  const {
    name,
    label,
    className,
    value,
    inputName,
    onClick,
    disabled,
    readOnly
  } = props;
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(name);
    }
  }, [name, onClick]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for
    React.createElement("label", {
      className: _cs(styles$a.radio, value && styles$a.active, className, disabled && styles$a.disabled, readOnly && styles$a.readOnly)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$a.icons
    }, value ? /*#__PURE__*/React.createElement(IoRadioButtonOn, {
      className: styles$a.icon
    }) : /*#__PURE__*/React.createElement(IoRadioButtonOff, {
      className: styles$a.icon
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$a.content
    }, label), /*#__PURE__*/React.createElement("input", {
      className: styles$a.input,
      type: "radio",
      name: isDefined(inputName) ? String(inputName) : undefined,
      checked: value,
      onClick: handleClick,
      disabled: disabled
    }))
  );
}

var styles$9 = {"radioInput":"styles_radio-input__363UQ","inputLabel":"styles_input-label__3EKZg","disabled":"styles_disabled__3Hdbl","inputError":"styles_input-error__2CrDM","inputHint":"styles_input-hint__2jCuV","radioListContainer":"styles_radio-list-container__3g2OC"};

function RadioInput(props) {
  const {
    className,
    name,
    options,
    value,
    onChange,
    keySelector,
    labelSelector,
    label,
    labelContainerClassName,
    listContainerClassName,
    error,
    hint,
    hintContainerClassName,
    errorContainerClassName,
    renderer = Radio,
    rendererParams: rendererParamsFromProps,
    disabled,
    readOnly
  } = props;
  const handleRadioClick = React.useCallback(radioKey => {
    if (onChange && !readOnly) {
      onChange(radioKey, name);
    }
  }, [readOnly, onChange, name]);
  const rendererParams = React.useCallback((key, item) => {
    // NOTE: this is required becase this is advance usecase
    // and the typings
    const radioProps = {
      inputName: name,
      label: labelSelector(item),
      name: key,
      onClick: handleRadioClick,
      value: key === value,
      disabled,
      readOnly
    };
    const combinedProps = { ...(rendererParamsFromProps ? rendererParamsFromProps(item) : undefined),
      ...radioProps
    };
    return combinedProps;
  }, [name, labelSelector, value, handleRadioClick, rendererParamsFromProps, disabled, readOnly]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$9.radioInput, disabled && styles$9.disabled, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(labelContainerClassName, styles$9.inputLabel, disabled && styles$9.disabled)
  }, label), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$9.radioListContainer, listContainerClassName)
  }, /*#__PURE__*/React.createElement(List$1, {
    data: options,
    rendererParams: rendererParams,
    renderer: renderer,
    keySelector: keySelector
  })), /*#__PURE__*/React.createElement("div", {
    className: _cs(errorContainerClassName, styles$9.error)
  }, error), !error && hint && /*#__PURE__*/React.createElement("div", {
    className: _cs(hintContainerClassName, styles$9.hint)
  }, hint));
}

var styles$8 = {"segment":"styles_segment__1O0zT"};

function Segment(props) {
  const {
    label,
    name,
    onClick,
    value,
    className,
    inputName,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    className: _cs(styles$8.segment, className),
    name: name,
    onClick: onClick,
    variant: value ? 'primary' : 'default'
  }), label);
}

// eslint-disable-next-line @typescript-eslint/ban-types
function SegmentInput(props) {
  const {
    rendererParams,
    listContainerClassName,
    keySelector,
    labelSelector,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(RadioInput, _extends({}, otherProps, {
    renderer: Segment,
    rendererParams: rendererParams,
    listContainerClassName: listContainerClassName,
    keySelector: keySelector,
    labelSelector: labelSelector
  }));
}

var styles$7 = {"switchIcon":"styles_switch-icon__2VfbS","light":"styles_light__1A3J6","dark":"styles_dark__1I3Bw","knob":"styles_knob__3dCcS","on":"styles_on__3nXSr"};

function SwitchIcon(props) {
  const {
    className,
    value,
    uiMode
  } = props;
  const themeClassName = useThemeClassName(uiMode, styles$7.light, styles$7.dark);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles$7.switchIcon, className, value ? styles$7.on : styles$7.off, themeClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7.knob
  }));
}

function Switch(props) {
  return /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, {
    checkmark: SwitchIcon
  }));
}

var styles$6 = {"svgContainer":"styles_svg-container__u7TJA","svg":"styles_svg__12ZxB"};

function Svg(props) {
  const {
    className,
    src
  } = props;
  const [id] = useState(() => `svg-${randomString(16)}`);
  const [svgId] = useState(() => `svg-${randomString(16)}`);
  useEffect(() => {
    const div = document.getElementById(id);

    if (div) {
      const svg = document.createElement('svg');
      svg.setAttribute('id', svgId);
      svg.setAttribute('class', styles$6.svg);
      svg.setAttribute('data-src', src);
      div.appendChild(svg);
      SVGInjector(svg);
    }

    return () => {
      const mySvg = document.getElementById(svgId);

      if (mySvg) {
        mySvg.remove();
      }
    };
  }, [id, svgId, src]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: _cs(className, styles$6.svgContainer)
  });
}

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap$1 = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource(WeakMap$1));

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var WeakMap = global_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has$1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return has$1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has$1(O, IE_PROTO$1)) return O[IE_PROTO$1];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var ITERATOR$1 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$1].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ((NEW_ITERATOR_PROTOTYPE) && !has$1(IteratorPrototype$2, ITERATOR$1)) {
  createNonEnumerableProperty(IteratorPrototype$2, ITERATOR$1, returnThis);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

var defineProperty = objectDefineProperty.f;





var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has$1(target, TO_STRING_TAG$1)) {
      defineProperty(target, TO_STRING_TAG$1, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !toStringTagSupport) {
      createNonEnumerableProperty(target, 'toString', objectToString);
    }
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  return IteratorConstructor;
};

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

/* eslint-disable no-proto -- safe */



// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var redefine = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};

var IteratorPrototype = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
}

var $forEach = arrayIteration.forEach;


var STRICT_METHOD$1 = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

var forEach$1 = entryVirtual('Array').forEach;

var forEach = forEach$1;

var ArrayPrototype$2 = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

var forEach_1 = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype$2 || (it instanceof Array && own === ArrayPrototype$2.forEach)
    // eslint-disable-next-line no-prototype-builtins -- safe
    || DOMIterables.hasOwnProperty(classof(it)) ? forEach : own;
};

var propertyIsEnumerable = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};

var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
_export({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var values$1 = path.Object.values;

var values = values$1;

var styles$5 = {"th":"styles_th__2jd9m","resizeHandle":"styles_resize-handle__3o4g1"};

function TableHeader(props) {
  const {
    className,
    children,
    onResize,
    onResizeComplete,
    name,
    ...otherProps
  } = props;
  const elementRef = React.useRef(null);
  const mouseDownXOnResizeHandleRef = React.useRef();
  const headingWidthRef = React.useRef();
  const finalHeadingWidthRef = React.useRef(); // FIXME: this should temporarily just update the dom

  const handleMouseMove = React.useCallback(e => {
    if (isDefined(mouseDownXOnResizeHandleRef.current) && elementRef.current && onResize) {
      e.preventDefault();
      e.stopPropagation();
      const dx = e.clientX - mouseDownXOnResizeHandleRef.current;

      if (isDefined(headingWidthRef.current)) {
        const newWidth = headingWidthRef.current + dx;
        finalHeadingWidthRef.current = newWidth;
        onResize(newWidth, name);
      } else {
        var _elementRef$current;

        headingWidthRef.current = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.offsetWidth;
      }
    }
  }, [onResize, name]);
  const handleResizeHandleMouseDown = React.useCallback(e => {
    var _elementRef$current2;

    e.preventDefault();
    mouseDownXOnResizeHandleRef.current = e.clientX;
    headingWidthRef.current = (_elementRef$current2 = elementRef.current) === null || _elementRef$current2 === void 0 ? void 0 : _elementRef$current2.offsetWidth;
    window.addEventListener('mousemove', handleMouseMove, true);
  }, [handleMouseMove]);
  React.useEffect(() => {
    const handleMouseUp = () => {
      mouseDownXOnResizeHandleRef.current = undefined;
      headingWidthRef.current = undefined;

      if (onResizeComplete && isDefined(finalHeadingWidthRef.current)) {
        onResizeComplete(finalHeadingWidthRef.current, name);
      }

      window.removeEventListener('mousemove', handleMouseMove, true);
    };

    window.addEventListener('mouseup', handleMouseUp, true);
    return () => {
      window.removeEventListener('mouseup', handleMouseUp, true);
      window.removeEventListener('mousemove', handleMouseMove, true);
    };
  }, [handleMouseMove, name, onResizeComplete]);
  return /*#__PURE__*/React.createElement("th", _extends({
    ref: elementRef,
    className: _cs(className, styles$5.th)
  }, otherProps), onResize && /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: styles$5.resizeHandle,
    onMouseDown: handleResizeHandleMouseDown
  }), children);
}

function TableRow(props) {
  const {
    className,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement("tr", _extends({
    className: className
  }, otherProps), children);
}

var styles$4 = {"td":"styles_td__1iLVn"};

function TableData(props) {
  const {
    className,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement("td", _extends({
    className: _cs(className, styles$4.td)
  }, otherProps), children);
}

var styles$3 = {"table":"styles_table__2-j79","column":"styles_column__8SP7m","headerRow":"styles_header-row__3VURX","headerCell":"styles_header-cell__2Luka","headerComponent":"styles_header-component__3bv9w","row":"styles_row__1YMwL","cell":"styles_cell__1XLOM","rowHeaderCell":"styles_row-header-cell__2H5Mv","numberCell":"styles_number-cell__3-BRO","numberCellHeader":"styles_number-cell-header__2n1B6","titleContainer":"styles_title-container__u8btv","title":"styles_title__eDa84"};

const DEFAULT_COLUMN_WIDTH = 108;

function getColumnWidth(column, width) {
  var _ref;

  return (_ref = width !== null && width !== void 0 ? width : column.columnWidth) !== null && _ref !== void 0 ? _ref : DEFAULT_COLUMN_WIDTH;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Table(props) {
  const {
    data,
    keySelector,
    columns,
    caption,
    className,
    captionClassName,
    headerRowClassName,
    headerCellClassName,
    rowClassName,
    cellClassName,
    uiMode,
    rowModifier,
    fixedColumnWidth,
    resizableColumn
  } = props;
  const [tableName] = React.useState(() => randomString());
  const themeClassName = useThemeClassName(uiMode, styles$3.light, styles$3.dark);
  const [columnWidths, setColumnWidths] = React.useState({});
  const handleColumnResize = React.useCallback((width, name) => {
    const column = document.getElementById(`${tableName}-${name}`);

    if (column) {
      column.style.width = `${width}px`;

      if (fixedColumnWidth) {
        const table = document.getElementById(tableName);

        if (table) {
          const totalWidth = sum(map(columns).call(columns, c => getColumnWidth(c, c.id === name ? width : columnWidths[c.id])));
          table.style.width = `${totalWidth}px`;
        }
      }
    }
  }, [tableName, columnWidths, columns, fixedColumnWidth]);
  const handleColumnResizeComplete = React.useCallback((width, name) => {
    if (isDefined(name)) {
      setColumnWidths(prevColumnWidths => ({ ...prevColumnWidths,
        [name]: width
      }));
    }
  }, [setColumnWidths]);
  const safeColumnWidths = React.useMemo(() => {
    const newColumnWidths = {};

    forEach_1(columns).call(columns, c => {
      newColumnWidths[c.id] = getColumnWidth(c, columnWidths[c.id]);
    });

    return newColumnWidths;
  }, [columnWidths, columns]);
  const width = React.useMemo(() => sum(values(safeColumnWidths)), [safeColumnWidths]);
  return /*#__PURE__*/React.createElement("table", {
    className: _cs(styles$3.table, className, themeClassName),
    style: fixedColumnWidth ? {
      width: `${width}px`
    } : undefined,
    id: tableName
  }, caption && /*#__PURE__*/React.createElement("caption", {
    className: captionClassName
  }, caption), /*#__PURE__*/React.createElement("colgroup", null, map(columns).call(columns, column => {
    const {
      id,
      columnClassName
    } = column;
    const columnWidth = safeColumnWidths[id];
    const style = {
      width: `${columnWidth}px`
    };
    return /*#__PURE__*/React.createElement("col", {
      id: `${tableName}-${id}`,
      style: style,
      key: id,
      className: _cs(styles$3.column, columnClassName)
    });
  })), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(TableRow, {
    className: _cs(styles$3.headerRow, headerRowClassName)
  }, map(columns).call(columns, (column, index) => {
    const {
      id,
      title,
      headerCellRenderer: Renderer,
      headerCellRendererClassName,
      headerCellRendererParams,
      headerContainerClassName
    } = column;
    const children = /*#__PURE__*/React.createElement(Renderer, _extends({}, headerCellRendererParams, {
      name: id,
      title: title,
      index: index,
      className: _cs(headerCellRendererClassName, styles$3.headerComponent)
    }));
    return /*#__PURE__*/React.createElement(TableHeader, {
      key: id,
      scope: "col",
      name: id,
      onResize: resizableColumn ? handleColumnResize : undefined,
      onResizeComplete: resizableColumn ? handleColumnResizeComplete : undefined,
      className: _cs(styles$3.headerCell, headerCellClassName, headerContainerClassName)
    }, children);
  }))), /*#__PURE__*/React.createElement("tbody", null, data === null || data === void 0 ? void 0 : map(data).call(data, (datum, index) => {
    const key = keySelector(datum, index);

    const cells = map(columns).call(columns, column => {
      const {
        id,
        cellRenderer: Renderer,
        cellRendererClassName,
        cellRendererParams,
        cellContainerClassName
      } = column;
      const otherProps = cellRendererParams(key, datum, index);
      const children = /*#__PURE__*/React.createElement(Renderer, _extends({}, otherProps, {
        className: cellRendererClassName,
        name: id
      }));
      return /*#__PURE__*/React.createElement(TableData, {
        key: id,
        className: _cs(styles$3.cell, cellClassName, cellContainerClassName)
      }, children);
    });

    const row = /*#__PURE__*/React.createElement(TableRow, {
      key: key,
      className: _cs(styles$3.row, rowClassName)
    }, cells);
    let modifiedRow = row;

    if (rowModifier) {
      modifiedRow = rowModifier({
        rowKey: key,
        row,
        cells,
        columns,
        datum
      });
    }

    return modifiedRow;
  })));
}

function Cell(props) {
  const {
    className,
    value
  } = props;

  if (isNotDefined(value)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, value);
}

var Cell$1 = typedMemo(Cell);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  _export({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}

// eslint-disable-next-line es/no-json -- safe
if (!path.JSON) path.JSON = { stringify: JSON.stringify };

// eslint-disable-next-line no-unused-vars -- required for `.length`
var stringify$1 = function stringify(it, replacer, space) {
  return path.JSON.stringify.apply(null, arguments);
};

var stringify = stringify$1;

function TextInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    ...textInputProps
  } = props;
  const containerRef = React.useRef(null);
  const inputSectionRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(InputContainer, {
    ref: containerRef,
    inputSectionRef: inputSectionRef,
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(RawInputWithSuggestion, _extends({}, textInputProps, {
      containerRef: containerRef,
      inputSectionRef: inputSectionRef,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      type: "text"
    }))
  });
}

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
_export({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});

var reverse$1 = entryVirtual('Array').reverse;

var ArrayPrototype$1 = Array.prototype;

var reverse_1 = function (it) {
  var own = it.reverse;
  return it === ArrayPrototype$1 || (it instanceof Array && own === ArrayPrototype$1.reverse) ? reverse$1 : own;
};

var reverse = reverse_1;

function useSortState(defaultValue) {
  const [sorting, setSorting] = useState(defaultValue);
  return {
    sorting,
    setSorting
  };
}
const initialValue$3 = {
  sorting: undefined,
  setSorting: state => {
    console.warn('Trying to set to ', state);
  }
};
const SortContext = /*#__PURE__*/createContext(initialValue$3);
function useSorting(sortParameter, columns, data) {
  const selectedSorter = useMemo(() => {
    const columnToSort = find(columns).call(columns, column => column.id === (sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.name));

    return columnToSort === null || columnToSort === void 0 ? void 0 : columnToSort.valueComparator;
  }, [columns, sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.name]);
  const sortedData = useMemo(() => {
    var _context3;

    if (!data || !selectedSorter) {
      return data;
    }

    if ((sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.direction) === 'dsc') {
      var _context, _context2;

      return reverse(_context = sort(_context2 = [...data]).call(_context2, selectedSorter)).call(_context);
    }

    return sort(_context3 = [...data]).call(_context3, selectedSorter);
  }, [data, selectedSorter, sortParameter === null || sortParameter === void 0 ? void 0 : sortParameter.direction]);
  return sortedData;
}

var $every = arrayIteration.every;


var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var every$1 = entryVirtual('Array').every;

var ArrayPrototype = Array.prototype;

var every_1 = function (it) {
  var own = it.every;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.every) ? every$1 : own;
};

var every = every_1;

function useFilterState(defaultValue) {
  const [filtering, setFiltering] = useState(defaultValue);
  const setFilteringItem = useCallback((id, value) => {
    setFiltering((oldFiltering = []) => {
      const index = findIndex(oldFiltering).call(oldFiltering, item => item.id === id);

      if (isNotDefined(value)) {
        const newFiltering = [...oldFiltering];

        if (index === -1) {
          console.error('There is some error');
        } else {
          splice(newFiltering).call(newFiltering, index, 1);
        }

        return newFiltering;
      }

      const newValue = { ...value,
        id
      };
      const newFiltering = [...oldFiltering];

      if (index === -1) {
        newFiltering.push(newValue);
      } else {
        splice(newFiltering).call(newFiltering, index, 1, newValue);
      }

      return newFiltering;
    });
  }, []);
  const getFilteringItem = useCallback(id => {
    if (!filtering) {
      return undefined;
    }

    return find(filtering).call(filtering, item => item.id === id);
  }, [filtering]);
  return {
    filtering,
    setFiltering,
    setFilteringItem,
    getFilteringItem
  };
}
const initialValue$2 = {
  filtering: undefined,
  setFiltering: state => {
    console.warn('Trying to set to ', state);
  },
  setFilteringItem: (id, state) => {
    console.warn(`Trying to set ${id} to `, state);
  },
  getFilteringItem: () => undefined
};
const FilterContext = /*#__PURE__*/createContext(initialValue$2);
function useFiltering(filterParameters, columns, data) {
  const filteredData = useMemo(() => {
    if (!filterParameters || filterParameters.length <= 0) {
      return data;
    }

    const columnsMapping = listToMap(columns, column => column.id, column => column);
    return data === null || data === void 0 ? void 0 : filter(data).call(data, datum => every(filterParameters).call(filterParameters, filterParameter => {
      let test = true;
      const {
        id,
        subMatch,
        greaterThanOrEqualTo,
        lessThanOrEqualTo
      } = filterParameter; // Identify if filtering is applied

      if (isNotDefined(greaterThanOrEqualTo) && isNotDefined(lessThanOrEqualTo) && isNotDefined(subMatch)) {
        return true;
      } // Filter out if we dont't have a column.valueSelector


      const column = columnsMapping[id];

      if (!(column !== null && column !== void 0 && column.valueSelector)) {
        return false;
      } // Filter out if value is undefined


      const val = column.valueSelector(datum);

      if (isNotDefined(val)) {
        return false;
      }

      if (typeof val === 'string') {
        test = isFalsyString(subMatch) || caseInsensitiveSubmatch(val, subMatch);
      } else {
        test = (isNotDefined(greaterThanOrEqualTo) || val >= greaterThanOrEqualTo) && (isNotDefined(lessThanOrEqualTo) || val <= lessThanOrEqualTo);
      }

      return test;
    }));
  }, [columns, data, filterParameters]);
  return filteredData;
}

function useOrderState(keys) {
  const [ordering, setOrdering] = useState(keys);
  const moveOrderingItem = useCallback((drag, drop) => {
    setOrdering(oldOrdering => {
      const dragPosition = findIndex(oldOrdering).call(oldOrdering, o => o.name === drag);

      const dropPosition = findIndex(oldOrdering).call(oldOrdering, o => o.name === drop);

      if (dragPosition === dropPosition) {
        return oldOrdering;
      }

      if (dragPosition === -1 || dropPosition === -1) {
        console.error('Drag or drop item could not be found');
        return oldOrdering;
      }

      const dragItem = oldOrdering[dragPosition];
      const newOrdering = [...oldOrdering];

      if (dragPosition > dropPosition) {
        splice(newOrdering).call(newOrdering, dragPosition, 1);

        splice(newOrdering).call(newOrdering, dropPosition, 0, dragItem);
      } else {
        splice(newOrdering).call(newOrdering, dropPosition + 1, 0, dragItem);

        splice(newOrdering).call(newOrdering, dragPosition, 1);
      }

      return newOrdering;
    });
  }, []);
  return {
    ordering,
    moveOrderingItem,
    setOrdering
  };
}
const initialValue$1 = {
  ordering: [],
  setOrdering: state => {
    console.warn('Trying to set to ', state);
  },
  moveOrderingItem: (drag, drop) => {
    console.warn(`Trying to drag item ${drag} to item ${drop}`);
  }
};
const OrderContext = /*#__PURE__*/createContext(initialValue$1);

function useOrdering(columns, ordering) {
  const filteredData = useMemo(() => {
    var _context;

    const mapping = listToMap(ordering, item => item.name, (item, __, index) => ({ ...item,
      order: index
    }));

    const sortedColumns = sort(_context = filter(columns).call(columns, foo => !!mapping[foo.id])).call(_context, (foo, bar) => {
      var _mapping$foo$id, _mapping$bar$id;

      // FIXME: this can be optimized
      const fooOrder = (_mapping$foo$id = mapping[foo.id]) === null || _mapping$foo$id === void 0 ? void 0 : _mapping$foo$id.order;
      const barOrder = (_mapping$bar$id = mapping[bar.id]) === null || _mapping$bar$id === void 0 ? void 0 : _mapping$bar$id.order;
      return compareNumber(fooOrder, barOrder);
    });

    return sortedColumns;
  }, [ordering, columns]);
  return filteredData;
}

const initialValue = {
  setHidden: state => {
    console.warn('Trying to set to ', state);
  }
}; // eslint-disable-next-line import/prefer-default-export

const HideContext = /*#__PURE__*/createContext(initialValue);

var styles$2 = {"headerCell":"styles_header-cell__21S0I","dragging":"styles_dragging__2DYB3","dropping":"styles_dropping__I6jWC","droppingBehind":"styles_dropping-behind__3hQIK","titleContainer":"styles_title-container__2X7z1","title":"styles_title__1bDvo","hideButton":"styles_hide-button__oUwii","grip":"styles_grip__3y32F","filterContainer":"styles_filter-container__2kj_V","textInput":"styles_text-input__2czV7","numberInput":"styles_number-input__231cJ","icon":"styles_icon__10nm5","rawInputContainer":"styles_raw-input-container__1WLtx"};

let tempDropInfo;

function HeaderCell(props) {
  const {
    className,
    uiMode,
    titleClassName,
    titleContainerClassName,
    title,
    name,
    index,
    sortable,
    defaultSortDirection = 'asc',
    filterType,
    orderable,
    hideable
  } = props;
  const {
    setHidden: onHide
  } = useContext(HideContext);
  const {
    moveOrderingItem: onReorder
  } = useContext(OrderContext);
  const {
    setFilteringItem: onFilterValueChange,
    getFilteringItem
  } = useContext(FilterContext);
  const filterValue = getFilteringItem(name);
  const {
    sorting,
    setSorting: onSortChange
  } = useContext(SortContext);
  const sortDirection = (sorting === null || sorting === void 0 ? void 0 : sorting.name) === name ? sorting.direction : undefined;
  const containerRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [dropInfo, setDropInfo] = useState();
  const handleHideClick = useCallback(() => {
    if (onHide) {
      onHide(name);
    }
  }, [onHide, name]);
  const handleSortClick = useCallback(() => {
    if (!onSortChange) {
      return;
    }

    let newSortDirection;

    if (!sortDirection) {
      newSortDirection = defaultSortDirection;
    } else if (sortDirection === 'asc') {
      newSortDirection = 'dsc';
    } else if (sortDirection === 'dsc') {
      newSortDirection = 'asc';
    }

    if (newSortDirection) {
      onSortChange({
        name,
        direction: newSortDirection
      });
    } else {
      onSortChange(undefined);
    }
  }, [name, onSortChange, sortDirection, defaultSortDirection]);
  const handleStringFilterChange = useCallback(value => {
    if (onFilterValueChange) {
      onFilterValueChange(name, { ...filterValue,
        subMatch: value
      });
    }
  }, [name, filterValue, onFilterValueChange]);
  const handleNumericFilterMinChange = useCallback(value => {
    if (onFilterValueChange) {
      onFilterValueChange(name, { ...filterValue,
        greaterThanOrEqualTo: value
      });
    }
  }, [name, filterValue, onFilterValueChange]);
  const handleNumericFilterMaxChange = useCallback(value => {
    if (onFilterValueChange) {
      onFilterValueChange(name, { ...filterValue,
        lessThanOrEqualTo: value
      });
    }
  }, [name, filterValue, onFilterValueChange]);
  const handleDragStart = useCallback(e => {
    setDragging(true);

    if (containerRef.current) {
      const size = containerRef.current.getBoundingClientRect();
      e.dataTransfer.setDragImage(containerRef.current, size.width, 0);
    }

    const content = {
      name,
      index
    };
    e.dataTransfer.dropEffect = 'move';
    e.dataTransfer.setData('text/plain', stringify(content));
    tempDropInfo = content;
  }, [index, name]);
  const handleDragEnd = useCallback(() => {
    setDragging(false);
    tempDropInfo = undefined;
  }, []);
  const handleDragEnter = useCallback(() => {
    // NOTE: this is a hack as we event.dataTransfer.getData() doesn't work
    setDropInfo(tempDropInfo);
  }, []);
  const handleDrop = useCallback(e => {
    if (!onReorder) {
      return;
    }

    try {
      const data = e.dataTransfer.getData('text/plain');
      const parsedData = JSON.parse(data);

      if (parsedData.name) {
        onReorder(parsedData.name, name);
      }
    } catch (ex) {
      console.error(ex);
    }
  }, [name, onReorder]);
  const {
    dropping,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop
  } = useDropHandler(handleDragEnter, handleDrop);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: _cs(className, styles$2.headerCell, dragging && styles$2.dragging, !dragging && dropping && (dropInfo && index > dropInfo.index ? styles$2.droppingBehind : styles$2.dropping)),
    onDragOver: onDragOver,
    onDragEnter: onDragEnter,
    onDragLeave: onDragLeave,
    onDrop: onDrop
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(titleContainerClassName, styles$2.titleContainer)
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(titleClassName, styles$2.title)
  }, sortable && /*#__PURE__*/React.createElement(Button, {
    name: "header-cell-sort",
    transparent: true,
    onClick: handleSortClick,
    title: "Sort column",
    uiMode: uiMode,
    compact: true
  }, !sortDirection && /*#__PURE__*/React.createElement(FaSort, null), sortDirection === 'asc' && /*#__PURE__*/React.createElement(FaSortUp, null), sortDirection === 'dsc' && /*#__PURE__*/React.createElement(FaSortDown, null)), /*#__PURE__*/React.createElement("div", null, title)), hideable && /*#__PURE__*/React.createElement(Button, {
    name: "header cell hide",
    className: styles$2.hideButton,
    transparent: true,
    onClick: handleHideClick,
    title: "Hide column",
    uiMode: uiMode,
    compact: true
  }, /*#__PURE__*/React.createElement(IoMdEyeOff, null)), orderable && /*#__PURE__*/React.createElement("div", {
    className: styles$2.grip,
    role: "presentation",
    draggable: true,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React.createElement(FaGripVertical, null))), filterType && /*#__PURE__*/React.createElement("div", {
    className: styles$2.filterContainer
  }, filterType === 'string' && /*#__PURE__*/React.createElement(TextInput, {
    name: "textFilter",
    icons: /*#__PURE__*/React.createElement(FaSearch, {
      className: styles$2.icon
    }),
    className: styles$2.textInput,
    inputContainerClassName: styles$2.rawInputContainer,
    value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.subMatch,
    placeholder: "Search",
    onChange: handleStringFilterChange
  }), filterType === 'number' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NumberInput, {
    name: "numberFilterMin",
    icons: /*#__PURE__*/React.createElement(FaGreaterThanEqual, {
      className: styles$2.icon
    }),
    className: styles$2.numberInput,
    inputContainerClassName: styles$2.rawInputContainer,
    value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.greaterThanOrEqualTo,
    placeholder: "Min",
    type: "number",
    onChange: handleNumericFilterMinChange
  }), /*#__PURE__*/React.createElement(NumberInput, {
    name: "numberFilterMax",
    icons: /*#__PURE__*/React.createElement(FaLessThanEqual, {
      className: styles$2.icon
    }),
    className: styles$2.numberInput,
    inputContainerClassName: styles$2.rawInputContainer,
    value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.lessThanOrEqualTo,
    placeholder: "Max",
    onChange: handleNumericFilterMaxChange
  }))));
}

var HeaderCell$1 = /*#__PURE__*/memo(HeaderCell);

function YesNoCell(props) {
  const {
    value,
    className
  } = props;

  if (isNotDefined(value)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, value ? 'Yes' : 'No');
}

function ExpandButton(props) {
  const {
    className,
    rowId,
    onClick,
    expanded = false
  } = props;
  return /*#__PURE__*/React.createElement(Button, {
    className: className,
    name: rowId,
    onClick: onClick,
    transparent: true
  }, expanded ? /*#__PURE__*/React.createElement(IoChevronDown, {
    title: "Expand row"
  }) : /*#__PURE__*/React.createElement(IoChevronForward, {
    title: "Collapse row"
  }));
}

function createYesNoColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    headerCellRenderer: HeaderCell$1,
    headerCellRendererClassName: options === null || options === void 0 ? void 0 : options.headerCellRendererClassName,
    headerContainerClassName: options === null || options === void 0 ? void 0 : options.headerContainerClassName,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable
    },
    cellRendererClassName: options === null || options === void 0 ? void 0 : options.cellRendererClassName,
    cellContainerClassName: options === null || options === void 0 ? void 0 : options.cellContainerClassName,
    cellRenderer: YesNoCell,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum)
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareBoolean(accessor(foo), accessor(bar)),
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}
function createStringColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    headerCellRenderer: HeaderCell$1,
    headerCellRendererClassName: options === null || options === void 0 ? void 0 : options.headerCellRendererClassName,
    headerContainerClassName: options === null || options === void 0 ? void 0 : options.headerContainerClassName,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable
    },
    cellRendererClassName: options === null || options === void 0 ? void 0 : options.cellRendererClassName,
    cellContainerClassName: options === null || options === void 0 ? void 0 : options.cellContainerClassName,
    cellRenderer: Cell$1,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum)
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareString(accessor(foo), accessor(bar)),
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}
function createNumberColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    headerCellRenderer: HeaderCell$1,
    headerCellRendererClassName: _cs(styles$3.numberCellHeader, options === null || options === void 0 ? void 0 : options.headerCellRendererClassName),
    headerContainerClassName: options === null || options === void 0 ? void 0 : options.headerContainerClassName,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable,
      titleClassName: styles$3.title,
      titleContainerClassName: styles$3.titleContainer
    },
    cellRendererClassName: _cs(styles$3.numberCell, options === null || options === void 0 ? void 0 : options.cellRendererClassName),
    cellContainerClassName: options === null || options === void 0 ? void 0 : options.cellContainerClassName,
    cellRenderer: Numeral,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum),
      placeholder: 'N/a'
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareNumber(accessor(foo), accessor(bar)),
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}
function createDateColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    headerCellRenderer: HeaderCell$1,
    headerCellRendererClassName: options === null || options === void 0 ? void 0 : options.headerCellRendererClassName,
    headerContainerClassName: options === null || options === void 0 ? void 0 : options.headerContainerClassName,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable
    },
    cellRendererClassName: options === null || options === void 0 ? void 0 : options.cellRendererClassName,
    cellContainerClassName: options === null || options === void 0 ? void 0 : options.cellContainerClassName,
    cellRenderer: DateTime,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum),
      format: 'date'
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareDate(accessor(foo), accessor(bar)),
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}
function createDateTimeColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    headerCellRenderer: HeaderCell$1,
    headerCellRendererClassName: options === null || options === void 0 ? void 0 : options.headerCellRendererClassName,
    headerContainerClassName: options === null || options === void 0 ? void 0 : options.headerContainerClassName,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable
    },
    cellRendererClassName: options === null || options === void 0 ? void 0 : options.cellRendererClassName,
    cellContainerClassName: options === null || options === void 0 ? void 0 : options.cellContainerClassName,
    cellRenderer: DateTime,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum),
      format: 'datetime'
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareDate(accessor(foo), accessor(bar)),
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}
function createExpandColumn(id, title, onClick, expandedRowId, options) {
  const item = {
    id,
    title,
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    headerCellRenderer: HeaderCell$1,
    headerCellRendererClassName: options === null || options === void 0 ? void 0 : options.headerCellRendererClassName,
    headerContainerClassName: options === null || options === void 0 ? void 0 : options.headerContainerClassName,
    headerCellRendererParams: {
      sortable: false,
      filterType: undefined,
      orderable: false,
      hideable: false
    },
    cellRendererClassName: options === null || options === void 0 ? void 0 : options.cellRendererClassName,
    cellContainerClassName: options === null || options === void 0 ? void 0 : options.cellContainerClassName,
    cellRenderer: ExpandButton,
    cellRendererParams: rowId => ({
      rowId,
      onClick,
      expanded: rowId === expandedRowId
    }),
    // valueSelector
    // valueComparator
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}

function convertTableData(data, columns) {
  if (!data) {
    return undefined;
  }

  return map(data).call(data, datum => {
    const val = {};

    forEach_1(columns).call(columns, header => {
      const {
        title,
        valueSelector
      } = header;
      const value = valueSelector ? valueSelector(datum) : undefined;
      val[title] = value;
    });

    return val;
  });
}
function convertJsonToCsv(data, columnDelimiter = ',', lineDelimiter = '\n', emptyValue = '') {
  if (!data || data.length <= 0) {
    return undefined;
  } // TODO: get exhaustive keys


  const keys = keys$1(data[0]);

  let result = keys.join(columnDelimiter);
  result += lineDelimiter;

  forEach_1(data).call(data, item => {
    var _context;

    result += map(_context = map(keys).call(keys, key => item[key])).call(_context, str => {
      if (isNotDefined(str)) {
        return emptyValue;
      }

      const val = String(str);

      if (includes(val).call(val, columnDelimiter)) {
        return `"${val}"`;
      }

      return val;
    }).join(columnDelimiter);
    result += lineDelimiter;
  });

  return result;
}

function useDownloading(name, valueCreator) {
  const handleClick = () => {
    const value = valueCreator();
    const csv = convertJsonToCsv(value);

    if (!csv) {
      return;
    }

    const blob = new Blob([csv], {
      type: 'text/csv'
    });
    const currentTimestamp = new Date().getTime();
    const fileName = `${name}-${currentTimestamp}.csv`;
    saveAs(blob, fileName);
  };

  return handleClick;
}

function useRowExpansion(expandedRowKey, expansionRowChildren, options = {}) {
  const {
    expandedRowClassName,
    expandedCellClassName,
    expansionCellClassName,
    expansionRowClassName
  } = options;
  const rowModifier = React.useCallback(rowOptions => {
    var _context;

    const {
      rowKey,
      row,
      columns
    } = rowOptions;
    const isActive = rowKey === expandedRowKey;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(row, {
      className: _cs(row.props.className, isActive && expandedRowClassName),
      children: map(_context = row.props.children).call(_context, cell => /*#__PURE__*/React.cloneElement(cell, {
        className: _cs(cell.props.className, isActive && expandedCellClassName)
      }))
    }), isActive && /*#__PURE__*/React.createElement(TableRow, {
      key: `${rowKey}-expanded`,
      className: expansionRowClassName
    }, /*#__PURE__*/React.createElement(TableData, {
      colSpan: columns.length,
      className: expansionCellClassName
    }, expansionRowChildren(rowOptions))));
  }, [expandedRowKey, expansionRowChildren, expandedRowClassName, expandedCellClassName, expansionRowClassName, expansionCellClassName]);
  return rowModifier;
}

function useRowExpansionOnClick(expansionRowChildren, options = {}) {
  const {
    expandedRowClassName,
    expandedCellClassName,
    expansionCellClassName,
    expansionRowClassName
  } = options;
  const [expandedRow, setExpandedRow] = React.useState();
  const rowModifier = React.useCallback(rowOptions => {
    var _context;

    const {
      rowKey,
      row,
      columns
    } = rowOptions;
    const isActive = rowKey === expandedRow;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(row, {
      onClick: () => {
        setExpandedRow(oldValue => oldValue === rowKey ? undefined : rowKey);
      },
      className: _cs(row.props.className, isActive && expandedRowClassName),
      children: map(_context = row.props.children).call(_context, cell => /*#__PURE__*/React.cloneElement(cell, {
        className: _cs(cell.props.className, isActive && expandedCellClassName)
      }))
    }), isActive && /*#__PURE__*/React.createElement(TableRow, {
      key: `${rowKey}-expanded`,
      className: expansionRowClassName
    }, /*#__PURE__*/React.createElement(TableData, {
      colSpan: columns.length,
      className: expansionCellClassName
    }, expansionRowChildren(rowOptions))));
  }, [expandedRow, setExpandedRow, expansionRowChildren, expandedRowClassName, expandedCellClassName, expansionRowClassName, expansionCellClassName]);
  return [rowModifier, !!expandedRow];
}

function useHash(value) {
  const [initialValue] = useState(value);
  const [hash, setHash] = useState(getHashFromBrowser());
  React.useEffect(() => {
    if (initialValue) {
      setHashToBrowser(initialValue);
    }
  }, [initialValue]);
  const handleHashChange = React.useCallback(() => {
    setHash(getHashFromBrowser());
  }, []);
  React.useEffect(() => {
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [handleHashChange]);
  return hash;
}

const TabsContext = /*#__PURE__*/React.createContext({
  disabled: false,
  activeTab: undefined,
  variant: 'primary',
  setActiveTab: () => {
    console.warn('setActiveTab called before it was initialized');
  }
});

var styles$1 = {"tab":"styles_tab__2DPfU","light":"styles_light__1xSrr","active":"styles_active__273J0","dark":"styles_dark__3ZYnx","tabList":"styles_tab-list__2fuSJ"};

function Tab(props) {
  const context = React.useContext(TabsContext);
  const {
    className,
    name,
    uiMode,
    ...otherProps
  } = props;
  let isActive = false;

  if (context.useHash) {
    isActive = context.hash === name;
  } else {
    isActive = context.activeTab === name;
  }

  const themeClassName = useThemeClassName(uiMode, styles$1.light, styles$1.dark);
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: _cs(className, styles$1.tab, isActive && styles$1.active, themeClassName),
    uiMode: uiMode,
    transparent: true,
    onClick: context.useHash ? setHashToBrowser : context.setActiveTab,
    name: name,
    role: "tab" // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps));
}
function TabList(props) {
  const {
    children,
    className,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: _cs(className, styles$1.tabList),
    role: "tablist"
  }), children);
}
function TabPanel(props) {
  const context = React.useContext(TabsContext);
  const {
    name,
    elementRef,
    ...otherProps
  } = props;
  let isActive;

  if (context.useHash) {
    isActive = context.hash === name;
  } else {
    isActive = context.activeTab === name;
  }

  if (!isActive) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    role: "tabpanel",
    ref: elementRef
  }));
}
function Tabs(props) {
  const {
    children,
    disabled
  } = props; // eslint-disable-next-line react/destructuring-assignment

  const defaultHash = props.useHash && isFalsyString(getHashFromBrowser()) // eslint-disable-next-line react/destructuring-assignment
  ? props.defaultHash : undefined; // eslint-disable-next-line react/destructuring-assignment

  const hash = useHash(props.useHash ? props.initialHash || defaultHash : undefined);
  console.warn(hash); // FIXME: destructuring here as props.value and props.onChange cannot be
  // added in dependency list
  // eslint-disable-next-line react/destructuring-assignment

  const onChange = !props.useHash ? props.onChange : undefined; // eslint-disable-next-line react/destructuring-assignment

  const value = !props.useHash ? props.value : undefined;
  const contextValue = React.useMemo(() => {
    // eslint-disable-next-line react/destructuring-assignment
    if (props.useHash) {
      return {
        disabled,
        hash,
        // eslint-disable-next-line react/destructuring-assignment
        useHash: props.useHash
      };
    } // Note: following cast is required since we do not have any other method
    // to provide template in the context type


    return {
      disabled,
      activeTab: value,
      setActiveTab: onChange
    };
  }, [// eslint-disable-next-line react/destructuring-assignment
  props.useHash, value, onChange, disabled, hash]);
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: contextValue
  }, children);
}

var styles = {"rawTextArea":"styles_raw-text-area__19Aur"};

/**
 * The most basic input component (without styles)
 */
function RawTextArea({
  className,
  onChange,
  uiMode,
  elementRef,
  value,
  name,
  style,
  disabled,
  readOnly,
  ...otherProps
}) {
  const handleChange = React.useCallback(e => {
    const {
      currentTarget: {
        value: v
      }
    } = e;

    if (onChange) {
      onChange(v === '' ? undefined : v, name, e);
    }
  }, [name, onChange]);
  const themeClassName = useThemeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement(TextareaAutosize, _extends({
    ref: elementRef,
    className: _cs(className, styles.rawTextArea, themeClassName),
    onChange: handleChange,
    name: name,
    value: value !== null && value !== void 0 ? value : '',
    autoComplete: "off",
    style: style,
    disabled: disabled || readOnly,
    readOnly: readOnly,
    minRows: 3,
    maxRows: 10 // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps));
}

function TextArea(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    ...textAreaProps
  } = props;
  return /*#__PURE__*/React.createElement(InputContainer, {
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(RawTextArea, _extends({}, textAreaProps, {
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled
    }))
  });
}

function TimeInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    onChange,
    name,
    ...rawInputProps
  } = props;
  const handleNowSet = useCallback(() => {
    if (!onChange) {
      return;
    }

    const value = getLocalISOString().substr(11, 5);
    onChange(value, name, undefined);
  }, [onChange, name]);
  return /*#__PURE__*/React.createElement(InputContainer, {
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    input: /*#__PURE__*/React.createElement(RawInput, _extends({}, rawInputProps, {
      name: name,
      onChange: onChange,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      type: "time"
    })),
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, !readOnly && /*#__PURE__*/React.createElement(Button, {
      onClick: handleNowSet,
      disabled: disabled,
      transparent: true,
      compact: true,
      uiMode: uiMode,
      name: undefined,
      title: "Set now"
    }, /*#__PURE__*/React.createElement(IoMdTime, null)))
  });
}

function easeOutCubic(x) {
  return 1 - (1 - x) ** 3;
}

function useCounter(to, interval, easing) {
  const [count, setCount] = useState(isDefined(to) ? 0 : undefined);
  const countRef = useRef(count);
  const fromRef = useRef(count);
  const startTimeRef = useRef();
  const requestRef = useRef();
  const animate = useCallback(now => {
    if (!startTimeRef.current) {
      startTimeRef.current = now;
    }

    const {
      current: startTime
    } = startTimeRef;
    const {
      current: from
    } = fromRef;
    const relativeTime = Math.min(now - startTime, interval);
    const relativeProgress = relativeTime / interval;
    const transitionedProgress = easing === 'linear' ? relativeProgress : easeOutCubic(relativeProgress);
    const relativeValue = isNotDefined(from) || isNotDefined(to) ? undefined : from + transitionedProgress * (to - from);
    countRef.current = relativeValue;
    setCount(relativeValue);

    if (relativeProgress < 1) {
      requestRef.current = requestAnimationFrame(animate);
    }
  }, [interval, to, easing]);
  React.useEffect(() => {
    var _countRef$current;

    if (isNotDefined(to)) {
      countRef.current = undefined;
      setCount(undefined);
      return undefined;
    }

    startTimeRef.current = undefined;
    fromRef.current = (_countRef$current = countRef.current) !== null && _countRef$current !== void 0 ? _countRef$current : 0;
    requestRef.current = requestAnimationFrame(animate);
    return () => {
      if (isDefined(requestRef.current)) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, [animate, to, interval]); // Make sure the effect runs only once

  return count;
}

export { Accordion, Avatar, Backdrop, BarChart, BodyBackdrop, Button, CheckListInput, Checkbox, Checkmark, Chip, ConfirmButton, Cover, DateInput, DateRangeDualInput, DateRangeInput, DateTime, DateTimeInput, DateTimeRange, FilterContext, HideContext, InputContainer, List$1 as List, index as Message, Modal, MultiSelectInput, NumberInput, Numeral, OrderContext, Pager, PasswordInput, PendingAnimation, PendingMessage, Popup, PopupButton, Portal, RadioInput, RawButton, RawInput, RawInputWithSuggestion, SearchMultiSelectInput, SearchSelectInput, SegmentInput, SelectInput, SelectInputContainer, SortContext, Svg, Switch, SwitchIcon, Tab, TabList, TabPanel, Table, Cell$1 as TableCell, TableData, TableHeader, HeaderCell$1 as TableHeaderCell, TableRow, Tabs, TextArea, TextInput, ThemeContext, TimeInput, ToggleButton, VisualFeedback, YesNoCell as YesNo, convertJsonToCsv, convertTableData, createDateColumn, createDateTimeColumn, createExpandColumn, createNumberColumn, createStringColumn, createYesNoColumn, useButtonFeatures, useCounter, useDownloading, useFilterState, useFiltering, useOrderState, useOrdering, useSortState, useSorting, useRowExpansion as useTableRowExpansion, useRowExpansionOnClick as useTableRowExpansionOnClick };
//# sourceMappingURL=index.es.js.map
